import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { EndgamePage } from '../endgame/endgame';
import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Events } from 'ionic-angular';

import introJs from 'intro.js/intro.js';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';
import { ThermometerBarComponent } from '../../components/thermometer-bar/thermometer-bar';

//import easeljs from '../../assets/js/easeljs';
//import createjs from '../../assets/js/createjs';
//import * as easeljs from 'createjs-easeljs';
//import easeljs from 'createjs-easeljs';
//import createjs from 'createjs';
//import plus1 from '../../assets/js/plus1';

@Component({
  selector: 'page-play',
  templateUrl: 'play.html',
  host: { '(window:resize)': 'handleResizeEvents($event)','(document:keydown)': 'handleKeyboardEventsKeyDown($event)', '(document:keyup)': 'handleKeyboardEventsKeyUp($event)' }
})

export class PlayPage {
  @ViewChild('showntextscroll') private showntextscroll : ElementRef;  
  private scrollElement; 
  instext: string; 
  showntext:string;
  shiftOn:boolean;

  introJsVar:any;
  tutorialMessages:string[]=[];
  tutorialIdElement:string[]=[];
  tutorialPosition:string[]=[];

  textblocks=[];
  wholetext:string;
  numElementsToPlay:number;
  numSntTotalBook:number;
  textToShowPriorOrPosterior: string;
  lastSntToConsiderIndex:number;
  numSntToSkipInThisRound:number=0;

  // In Classic mode is the number of sentence (Bookmark)
  // In Shannon mode is number of the character inside the sentence (bookmarkLetter)
  indexElementToGuessInThisRound:number=0;

  numCorretGuessesAfterWhichGiveASkip:number = 2;
  counterNumCorretGuessesAfterWhichGiveASkip: number = 0;
  
  haskippedorguessed:number;
  haskippedorguessedplus:number;
  round:number;
  attempt: number;
  scorePartial:number;        // score of the current game withour bonus
  scoreFinalBonuses: number;  // bonus to score, see endgame
  scoreFinalAI: number;
  entropyFinalAI: number;
  numSbagliate: number;
  numCorrette: number;
  currentBookmark:number;
  currentBookmarkLetter:number;
  bookmarkAtGameBegin:number;
  bookmarkLetterAtGameBegin:number;
  currentChunk:number;
  currentChunkProgress:number;
  currentChunkStart:number;
  currentChunkEnd:number;
  currentChunkTotalChar:number;
  currentChunkScoreAtGameBegin:number;
  numChunksInBook:number;
  currentLevel:number;
  currentLevelProgress:number;
  currentScoreAi:number=0;
  currentThermometerProgress:number;
  currentThermometerColor:string;
  currentBlinkingCursorColor:string="green";
  currentColorCatVersus:string;
  chunkCharSkippedAtBeginningOrEndOfBook:number;
  finalEntropyValues=[];
  numLettersGuessedInCurrentChunkAtGameBegin:number;
  priorOrPosteriorIndexes=[];
  wasGameModeVersus:boolean;
  savedSettingsBeforeVersusGame=[];
  tutorialIsRunning:boolean;
  initialBonusGave: boolean;

  splitInSntTotal: string[]=[];
  splitInSnt: string[]=[];

  pauseInteractionWithKeyboard: boolean;
  time:number;
  timeFinal:number;

  isGameEndedBoolean: boolean;

  mood:string;

  randomGameBg:string;

  refreshIntervalId;
  refreshVersusIntervalId;
  pauseAnimationIntervalId;

  currentKeyboard:number;

  // ad es, if I have keyboard 0 1 2 and 3 this is 4
  numKeyboardsAvailable:number;
  numLettersInSingleKeyboards:number;

  // Last button MUST be space
  // num letter in each keyboard MUST be the same for thanos mode to work
  // TODO access this var from css to create an adaptive design
  keyboards={
    'en':{
      0:['q','w','e','r','t','y','u','i','o','p',
         'a','s','d','f','g','h','j','k','l',';',
         ':','z','x','c','v','b','n','m',',','.',
         ' '],
      1:['1','2','3','4','5','6','7','8','9','0',
        '$','£','-','?','!','\'','','','','',
        '','','','','','','','','','',
        ' '],
    },
    'it':{
      0:['q','w','e','r','t','y','u','i','o','p',
         'a','s','d','f','g','h','j','k','l',';',
         ':','z','x','c','v','b','n','m',',','.',
         ' '],
      1:['1','2','3','4','5','6','7','8','9','0',
        '$','£','-','?','!','\'','à','è','é','ì',
        'ò','ó','ù','','','','','','','',
        ' '],
    }
  }

  // Last 'false' is for space button
  letterTriedInThisRound={
    0:[false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false],
    1:[false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false],
    2:[false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false,false,false,false,false,false,false,false,false,false,false,
      false]
  }

  initialGameDataForVersus; // data coming from server
  opponentGameDataVersus; // elaborated data
  opponentCurrentAttempt; // holds the current attempt of the opponent in time
  guidUserVersus;
  idGameVersus;
  minBookmarkReachedOpponent; // minimun index bookmark reached by opponent during his game
  maxBookmarkReachedOpponent;

  // This array is something like [ [[1,2],[1,4]] , [[1,3]] ]
  /* Contains one element Z for each character playable in the current game (this.getSlicedTextblockToGuess().length)
  and a couple [X,Y] for each character Z with index Y and keyboard X in array letterTriedInThisRound tried in the previuos rounds
  As you move the cursor, the array letterTriedInThisRound is rebuilded according to listOfLetterTriedInThisRound content
  Is used in classical mode and in hangman, for, even in classic mode, there is need to remember letter guessed wrong in previous games
  */ 
  listOfLetterTriedInThisRound=[];

  // boolean array el[i] (i=0 to N)
  // i corrispond to i element of slicedTextblock, is a number M equal to the attempt wrong done on i letter
  maxAttemptsWrong=[];

  // boolean array el[i] (i=0 to N)
  // i corrispond to i element of between startBookmark and endBookmark given in getMaxAttemptsTotal, is a number M equal to the attempt done on i letter (wrong+1 if guessed right)
  maxAttemptsTotal=[];

  // number array el[i] (i=0 to N)
  // i corrispond to i element of slicedTextblock, is true or false if i letter was guessed before or not
  lettersGuessedOrNotHangman:boolean[];

  // object array el[i] (i=0 to N with max elements of current chunk)
  // i corrispond to i element of current chunk, is a object containing data par for character i in chunk
  // It is NOT going with slicedTextblock for the last element of any chunk doesn't have a record for par
  parsOfTextblock=[];

  // el[i] is true if character i was guessed right by opponent during this game playback at the current time
  lettersGuessedOrNotHangmanVersusOpponent;
  fartherIndexDashReachedDuringGame=-1;

  // This array is something like [ [[a,b],[j,f]] , [[g,k,D]] ]
  /* Contains one element Z for each character playable in the current game (this.getSlicedTextblockToGuess().length)
  functionsnumErrorAfterWhichThanosHit=3;
  The element is [0] at beginning, [1] at first error of the user, [N] at error N and over this.functions.numErrorAfterWhichThanosHit
  the Thanos removal begins and it becames a list of character removed when Thanos hit
  */ 
  lettersRemovedWhenThanosHit=[];

  currentGuessableString:string="";
  showablecurrentGuessableString;

  constructor(public functions: Functions, public http: Http, public rubedoSideMenu: MenuController, public translate: TranslateService, public events: Events, public ThermometerBar: ThermometerBarComponent, public userdataModel:UserdataModel, public navCtrl: NavController, private navParams: NavParams,private storage: Storage, public playModel: GameModel, public gamesrulesModel: GamerulesModel, public smartAudio: SmartAudio, public dataExchanger:DataExchanger, public sanitizer: DomSanitizer) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);

    this.introJsVar=introJs.introJs();
    this.mood='clueless';
  }

  /* --------- LIFECYCLE --------- */
  ionViewDidLoad(){
    //this.showntextRef.nativeElement.style.color = "red";
    //this.showntextRef.nativeElement.style.width = this.round+'px';
  }

  ionViewWillEnter(){
    // before the page in question becomes active
    
    // remove menu
    document.getElementById('sideMenuButton').style.display='none';

    //document.getElementById('skip').style.cssText='width:48% !important';
    
    this.counterNumCorretGuessesAfterWhichGiveASkip=0;
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.stopBgMusic('app_BgMusic');
    this.randomGameBg=this.functions.getRandomGameBg();
    this.functions.startBgMusic(this.randomGameBg);
    this.setKeyboardsSizes();
    //this.setShiftStatus(false);

    this.begingame();
  }

  ionViewWillLeave(){
    //before the page leaves the viewport
    //document.getElementById('sideMenuButton').style.display='block'; //This is commented to avoid flash of the menu reapperaing and disappearing in endgame page    this.functions.setDifficulty();
    this.functions.setGameMode();
    this.functions.setLanguage();

    this.introJsVar.exit(); // if we are leaving the play page and the intro is active, close it
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
    //after the page in question becomes active
    //console.log(this.showntextscroll.nativeElement.scrollHeight);
    this.scrollOnFocusText();    
    
    // TODO add not start if you finished already the tutorial
    /*if(this.playModel.getNumGamesPlayed()<=this.functions.numMaxGamesDisplayWalktroughtMsg
        && !this.userdataModel.isGotCollectibleNum(1)
        && !this.functions.isBigScreen()
        && !this.functions.isRunningOnIos() ){
      this.functions.showWalkthroughWithMessageWithButtons("fullscreenMsg_1","superhappy");
      document.getElementById("start_tutorial_yes").addEventListener("click",() => { this.functions.hideWalkthrough(); this.startTutorial(); })
    }*/
  }

  ionViewDidLeave(){
    //after the page leaves the viewport
  }

  ionViewWillUnload(){
    //before the page is removed from the DOM
  }
  /* --------- END LIFECYCLE --------- */

  /* --------- FUNCTIONS --------- */
  ngDoCheck() {
    // zozzata: faccio scrollare giù ogni volta che il tempo passato è multiplo di tot così 
    // l'utente può guardare il testo tra 0 e tot secondi
    // idem faccio scrollare per un paio di secondi dopo che è stato fatto uno skip
    // o un indovina sennò scendeva fino all'altezza della frase precedente (non faceva in tempo ad
    // apparire la frase dopo allungando l'altezza della finestra
    
    
    //TODO riabilitare scroll?
    /*
    var haskippedorguessedplus=this.haskippedorguessed-2;
    if(this.time%15==0 
      || this.time>=haskippedorguessedplus){
        this.scrollOnFocusText();
    }*/
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }

  tryWord(){
    //this.userdataModel.setCollectibleGot(23);
    var numLetterToRemoveInThanosMode;
    var indexesToChooseLetterToRemoveInThanosMode=[];
    var tmpKeyboard=0;
    var tmpIndexLetterInKeyboard=0;
    var tmpIndexRightWordInKeyboard;
    var scoreEarned;
    if(this.functions.isGameModeShannon()){
      this.setLetterTried(this.getIndexInKeyboards(this.instext,"allKeyboards","returnAllIndexes","changeKeyboardWithIndexFound"),-1); 
    }
    if(!this.functions.isGameModeShannon()){
      this.animateButtonClicked('try','colorgrey');
    }
    this.haskippedorguessed=this.time;

    // Guessed right
    if(this.functions.normalizeWordForComparison(this.instext)==this.functions.normalizeWordForComparison(this.getElementToGuess())){
      console.log("wordProposed:|"+this.functions.normalizeWordForComparison(this.instext)+"|"+"  wordToGuess:|"+this.functions.normalizeWordForComparison(this.getElementToGuess())+"|"+"Try Result: RIGHT");
      this.functions.play('claps');

      if (!this.functions.isGameModeShannon()) {
        this.counterNumCorretGuessesAfterWhichGiveASkip++;
        if(this.counterNumCorretGuessesAfterWhichGiveASkip==this.numCorretGuessesAfterWhichGiveASkip){
          this.userdataModel.addSkip(1);
          this.counterNumCorretGuessesAfterWhichGiveASkip=0;
        }  
      }

      this.lettersGuessedOrNotHangman[this.getIndexInSlicedArray(this.currentBookmarkLetter)]=true;

      scoreEarned = this.gamesrulesModel.calculateScore(this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)]+1,this.getParOfBookmark(this.currentBookmarkLetter));
      this.storeWordData(false, true, scoreEarned);
      /*if(this.mood=='happy'){
        this.mood='superhappy';
      }else{
        this.mood='happy';
      }*/

      //console.log("ADDING TO SCORE: "+scoreEarned);
      this.scorePartial=this.scorePartial+scoreEarned;
      this.currentLevel=this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()+this.scorePartial);
      this.currentLevelProgress=this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore()+this.scorePartial);
      
      this.numCorrette++; 
      this.updateCurrentChunkProgress();

      //this.time=this.time+5;

      this.changeRound();
      this.updateThermometer(this.currentBookmarkLetter);
    //Guessed Wrong
    }else{
      console.log("wordProposed:|"+this.functions.normalizeWordForComparison(this.instext)+"|"+"  wordToGuess:|"+this.functions.normalizeWordForComparison(this.getElementToGuess())+"|"+"Try Result: WRONG");
      if (this.functions.isGameModeShannon()) {
        this.animateButtonClicked('key_'+this.getIndexInKeyboards(this.instext,"currentKeyboard","returnSingleIndex","changeKeyboardWithIndexFound"),'colorred');
        this.pauseInteractionWithKeyboard=true;

        this.pauseAnimationIntervalId = setInterval(()=>{
          this.pauseInteractionWithKeyboard=false; 
          clearInterval(this.pauseAnimationIntervalId);
        },0);
      }

      // Thanos solution
      if(this.isThanosModeActive()){
        if(this.functions.isGameModeShannonHangman() 
        && this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound].length>0){ 
         // Thanos strikes once a letter after N errors

         //console.log("?????? tutto: "+JSON.stringify(this.lettersRemovedWhenThanosHit));
         //console.log("?????? no 0: "+JSON.stringify(this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound]));
         //console.log("?????? con 0: "+JSON.stringify(this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound][0]));
         //console.log("?????? log: "+isNaN(this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound][0]));
         if (this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound].length==1 
         && !isNaN(this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound][0])) { // if it is a number
          this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound][0]++; 
          if (this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound][0]>=this.functions.functionsnumErrorAfterWhichThanosHit) {
            this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound]=[];

            // TIME FOR THANOS TO STRIKE!
            //console.log("----- total num letters: "+(this.numLettersInSingleKeyboards*this.numKeyboardsAvailable));
            numLetterToRemoveInThanosMode = Math.floor((this.functions.percLetterToRemoveInThanosMode[this.functions.difficulty]/100)*(this.numLettersInSingleKeyboards*this.numKeyboardsAvailable));
            for (let i = 0; i < this.numLettersInSingleKeyboards*this.numKeyboardsAvailable; i++) {
              indexesToChooseLetterToRemoveInThanosMode.push(i);
            }
            //console.log("----- numLetterToRemoveInThanosMode: "+numLetterToRemoveInThanosMode);
            //console.log("----- indexesToChooseLetterToRemoveInThanosMode: "+JSON.stringify(indexesToChooseLetterToRemoveInThanosMode));
            
            // This remove the right character from the choice of letters to remove
            tmpIndexRightWordInKeyboard=this.getIndexInKeyboards(this.functions.normalizeWordForComparison(this.getElementToGuess()),"allKeyboards","returnAllIndexes","doNOTchangeKeyboardWithIndexFound");
            tmpIndexRightWordInKeyboard[0]=(tmpIndexRightWordInKeyboard[0][0]*this.numLettersInSingleKeyboards)+tmpIndexRightWordInKeyboard[0][1];
            indexesToChooseLetterToRemoveInThanosMode.splice(tmpIndexRightWordInKeyboard[0],1);

            // Shuffle the indexes to choose which letters to remove
            indexesToChooseLetterToRemoveInThanosMode=this.functions.fisherYatesShuffle(indexesToChooseLetterToRemoveInThanosMode);
            //console.log("----- indexesToChooseLetterToRemoveInThanosMode AFT SHUFFLE: "+JSON.stringify(indexesToChooseLetterToRemoveInThanosMode));
            
            for (let i = 0; i < numLetterToRemoveInThanosMode; i++) {
              tmpKeyboard=0;
              tmpIndexLetterInKeyboard=indexesToChooseLetterToRemoveInThanosMode[i];
              while (tmpIndexLetterInKeyboard>=this.numLettersInSingleKeyboards) {
                tmpKeyboard=tmpKeyboard+1;
                tmpIndexLetterInKeyboard=tmpIndexLetterInKeyboard-this.numLettersInSingleKeyboards;
              }
              //console.log("----- i: "+i+" tmpKeyboard: "+tmpKeyboard+" tmpIndexLetterInKeyboard: "+tmpIndexLetterInKeyboard);
              //console.log("----- set tried: "+this.keyboards[this.functions.language][tmpKeyboard][tmpIndexLetterInKeyboard]);
              this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound].push(this.keyboards[this.functions.language][tmpKeyboard][tmpIndexLetterInKeyboard]);
              this.setLetterTried(this.getIndexInKeyboards(this.keyboards[this.functions.language][tmpKeyboard][tmpIndexLetterInKeyboard],"allKeyboards","returnAllIndexes","doNOTchangeKeyboardWithIndexFound"),-1); 
              //console.log("----- lettersRemovedWhenThanosHit: "+JSON.stringify(this.lettersRemovedWhenThanosHit)); //mem letters
            }
          }
         }
        }
      }
      // END THANOS

      this.updateThermometer(this.currentBookmarkLetter);

      this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)]++;
      this.updateCurrentGuessableString();

      this.functions.play('kitten_meow');
      this.storeWordData(false, false, 0);

      /*switch (this.currentThermometerProgress) {
        case 'worried':
          this.mood='superworried';
          break;
        case 'superworried':
          this.mood='sad';
          break;
        case 'sad':
          this.mood='supersad';
          break;
        case 'supersad':
          this.mood='angry';
          break;
        case 'angry':
          this.mood='superangry';
          break;
        case 'superangry':
          this.mood='worried';
          break;
        default:
          this.mood='worried';
          break;
      }*/

      this.numSbagliate++;
      this.numCorrette;
    }
    this.instext='';
    this.attempt++;
  }

  skipWord(){
    this.haskippedorguessed=this.time;
    this.functions.play('kitten_meow');
    
    if(this.mood=='sad'){
      this.mood='supersad';
    }else{
      this.mood='sad';
    }
    
    this.userdataModel.useSkip();
    this.storeWordData(true, false, 0);

    this.instext='';
    this.attempt++;
    this.changeRound();

    if(this.isGameEnded()){
      this.endgame("end_classic");
    }
  }

  storeWordData(skip,correct,scoreEarned){  
    var wordIndex;
    var thanosReport="";

    if (this.functions.isGameModeShannon()) {
      wordIndex=-1;
    }else{
      wordIndex=this.textblocks[this.indexElementToGuessInThisRound].wordIndex
    }
    if (this.isThanosModeActive()) {
      thanosReport=this.lettersRemovedWhenThanosHit[this.indexElementToGuessInThisRound].join("")
    }
    this.playModel.addWord(
      this.functions.getIdCurrentBook(),
      this.playModel.getCurrentGameId(),
      this.round, //round
      this.attempt, //attempt
      this.currentBookmark, //currentBookmark
      this.currentBookmarkLetter, //currentBookmarkLetter
      this.time, //time
      this.userdataModel.getSkip(), //skipLeft
      this.functions.currentTimestamp(), //tsInsert
      skip, //skip
      thanosReport,
      this.instext, //word
      this.getElementToGuess(), //wordToGuess
      wordIndex, // wordIndex
      correct, // isCorrect
      scoreEarned, // scoreEarned
      this.maxAttemptsWrong[this.getIndexInSlicedArray(this.currentBookmarkLetter)] //attemptsWrong
    );    
  }

  storeFinalGameData(typeOfwin){
    var idGame = this.playModel.getCurrentGameId();
    this.playModel.setTsEndgame(idGame,this.functions.currentTimestamp());
    this.playModel.setScoreFinal(idGame,this.userdataModel.getScore());
    this.playModel.setLevelFinal(idGame,this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()));
    this.playModel.setSkipFinal(idGame,this.userdataModel.getSkip());    
    this.playModel.setBookmarkFinal(idGame,this.currentBookmark);
    this.playModel.setBookmarkLetterFinal(idGame,this.currentBookmarkLetter);
    this.playModel.setIdChunkInBookFinal(idGame,this.currentChunk);
    this.playModel.setFartherIndexDashReachedDuringGame(idGame,this.fartherIndexDashReachedDuringGame+this.getBeginSlicedTexblock());
    this.playModel.setNumCorrette(idGame,this.numCorrette);
    this.playModel.setNumSbagliate(idGame,this.numSbagliate);
    this.playModel.setWin(idGame,JSON.stringify(typeOfwin));
    if(this.timeFinal==-1){ this.timeFinal=this.time;}
    this.playModel.setTimeFinal(idGame,this.timeFinal);
    this.playModel.storeGamesData();

    return new Promise((resolve) =>{
      this.dataExchanger.storeUserGamedataOnServer(false).then((response)=>{
        this.dataExchanger.storeGamedataOnServer().then((response)=>{
          resolve();
        });
      });
    });
  }

  timer(){
    this.refreshIntervalId = setInterval(()=>{
      // Was time--
      if (!this.isGameEndedBoolean && !this.tutorialIsRunning) {
        this.time++;
      }
    
      /*if(this.time==10 || this.time==5){ 
        this.functions.play('tick_tock');
        this.mood='fear'; 
      }*/
      if(this.time==0){
        this.endgame("end_classic");
      }
    },1000);
  }

  endgame(typeOfwin){
    var chunkFinished;
    if (!this.isGameEndedBoolean) { // just not to allow endgame to fire twice
      // isGameEndedBoolean also stops time from ticking so not to add the take a breath second to time consumed during the game
      this.isGameEndedBoolean=true;
      this.pauseInteractionWithKeyboard=true;
      chunkFinished=false;

      // take a breath and go on (time for the player to see its last action)
      setTimeout(() => {
        this.updateIndexesAndBookmark(true);
        var idChunkInBookAtGameEnd=this.currentChunk;
        this.scoreFinalBonuses=0;

        if (!this.functions.isGameModeVersus()) {
          // Check if chunk is finished and update 
          // If chunk is finshed update chunk (+1 or -1 for classic or reverse mode) and time/progress/score starts from zero again

          this.userdataModel.setCurrentTime(this.time);
          this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(this.numLettersGuessedInCurrentChunkAtGameBegin+this.numCorrette);
          // there are bonus if chunk finished and in that case score is 0 so we don't add final bonuses. This must rethought if other bonus are applied
          this.userdataModel.setCurrentChunkScore(this.currentChunkScoreAtGameBegin+this.scorePartial); 

          /* --- ADDING BONUSES to score -- */
          if (!this.functions.isGameModeShannonReverse()
            && this.currentBookmarkLetter>this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),this.currentChunk)) {
            this.scoreFinalBonuses=this.scoreFinalBonuses+this.functions.bonusScore['chunkFinished'];
            chunkFinished=true;
            this.currentChunk=this.getNextChunk(this.currentChunk);
            this.userdataModel.setCurrentIdChunkInBook(this.currentChunk);
            this.userdataModel.setCurrentTime(0);
            this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(0);
            this.userdataModel.setCurrentChunkScore(0);
          }
          if (this.functions.isGameModeShannonReverse()
            && this.currentBookmarkLetter<this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),this.currentChunk)) {
            this.scoreFinalBonuses=this.scoreFinalBonuses+this.functions.bonusScore['chunkFinished'];
            chunkFinished=true;
            this.currentChunk=this.getNextChunk(this.currentChunk);
            this.userdataModel.setCurrentIdChunkInBook(this.currentChunk);
            this.userdataModel.setCurrentTime(0);
            this.userdataModel.setCurrentNumLettersGuessedInCurrentChunk(0);
            this.userdataModel.setCurrentChunkScore(0);
          }
          /* --- END ---- ADDING BONUSES to score -- */ 
          this.userdataModel.setBookmark(this.currentBookmark);
          this.userdataModel.setBookmarkLetter(this.currentBookmarkLetter);
          this.currentLevel=this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()+this.scorePartial+this.scoreFinalBonuses);
          this.currentLevelProgress=this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore()+this.scorePartial+this.scoreFinalBonuses);
        }else{
          // Versus mode          
          if (this.scorePartial>=this.scoreFinalAI) {
            typeOfwin="win_versus";
            chunkFinished=true;
          }else{
            typeOfwin="lost_versus";
          }
        }
        this.userdataModel.setScore(this.userdataModel.getScore()+this.scorePartial+this.scoreFinalBonuses);
        this.userdataModel.setLevel(this.gamesrulesModel.getLevelFromScore(this.userdataModel.getScore()+this.scorePartial+this.scoreFinalBonuses));

        this.storeFinalGameData(typeOfwin).then((response)=>{
          this.calculateFinalEntropyOfChunk(idChunkInBookAtGameEnd).then((response)=>{
            
            if (this.functions.isGameModeVersus()) {
              this.restoringSettingsAfterGameVersus();
              console.log("--------AFTER RESTORE--------"+"  Gamemode: "+this.functions.gamemode+"  Book: "+this.functions.getIdCurrentBook()+"  BEF is versus: "+this.functions.gamemodeVersusActive);
              this.functions.gamemodeVersusActive=false;
              console.log("  AFT is versus: "+this.functions.gamemodeVersusActive+" ----------------");
            }

            this.navCtrl.push(EndgamePage, {
              scorePartial: this.scorePartial,
              scoreFinalBonuses: this.scoreFinalBonuses,
              typeOfwin: typeOfwin,
              chunkFinished: chunkFinished,
              downEntropy: this.finalEntropyValues[0],
              upEntropy: this.finalEntropyValues[1],
              scoreFinalAI: this.scoreFinalAI,
              entropyFinalAI: this.entropyFinalAI,
              wasGameModeVersus: this.wasGameModeVersus
            });

            console.log("--------END GAME--------"+"  TypeOfwin: "+typeOfwin+"  ScorePartial: "+this.scorePartial+" and ScoreFinalBonuses: "+this.scoreFinalBonuses+"  Gamemode: "+this.functions.gamemode+"  Book:"+this.functions.getIdCurrentBook()+"  IdChunkInBookAtGameEnd: "+idChunkInBookAtGameEnd+" Chunk start: "+this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),idChunkInBookAtGameEnd)+" Chunk end: "+this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),idChunkInBookAtGameEnd)+"  BookmarkLetter: "+this.currentBookmarkLetter+" scoreFinalAI: "+this.scoreFinalAI+"  WasGameModeVersus: "+this.wasGameModeVersus+"  is versus: "+this.functions.gamemodeVersusActive+"  chunkFinished: "+chunkFinished+"  ----------------");
        
            clearInterval(this.refreshIntervalId);
            clearInterval(this.refreshVersusIntervalId);      
            this.functions.stopBgMusic(this.randomGameBg);
            this.showablecurrentGuessableString="";
            this.pauseInteractionWithKeyboard=false;
          });
        });
      }, 1500);
    }
  }

  giveUp(){
    this.pauseInteractionWithKeyboard=true;
    this.timeFinal=this.time;
    var idGame = this.playModel.getCurrentGameId();
    this.playModel.setGiveUp(idGame, true);
    if (this.functions.isGameModeVersus()) {
      this.endgame("lost_versus");
    } else {
      this.endgame("end_classic");
      //this.time=1;
    }
  }

  /* This move the bookmark numCharacterPriorOrPosterior character back (reverse mode) or forth (normal mode)
  to have a full prior or posterior text at end (reverse mode) or begin (normal mode) of the current book
  Long story short, this gift the first character of a book.
  */
  checkBootstrapBookmark(){
    var tmp;
    if (this.functions.isGameModeShannon() && !this.functions.isGameModeShannonReverse()) {
      tmp=this.functions.numCharacterPriorOrPosterior;
      if (this.bookmarkLetterAtGameBegin<tmp) {
        this.userdataModel.setBookmarkLetter(tmp);
        this.bookmarkLetterAtGameBegin=tmp;
      }
    }
    if (this.functions.isGameModeShannon() && this.functions.isGameModeShannonReverse()) {
      tmp=this.userdataModel.getIndexLastCharacterInBook()-this.functions.numCharacterPriorOrPosterior;
      if (this.bookmarkLetterAtGameBegin>tmp) {
        this.userdataModel.setBookmarkLetter(tmp);
        this.bookmarkLetterAtGameBegin=tmp;
      }
    }
  }

  fitBookmarkInsideChunk(){
    //this.currentChunkStart=this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),this.currentChunk);
    //this.currentChunkEnd=this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),this.currentChunk);

    //console.log("BEF fitBookmark bookmarkLetterAtGameBegin"+this.bookmarkLetterAtGameBegin+" currentBookmarkLetter"+this.currentBookmarkLetter);
    if (this.bookmarkLetterAtGameBegin<this.currentChunkStart) {
      this.userdataModel.setBookmarkLetter(this.currentChunkStart);
      this.bookmarkLetterAtGameBegin=this.currentChunkStart;
      this.currentBookmarkLetter=this.currentChunkStart;
    }

    if (this.bookmarkLetterAtGameBegin>this.currentChunkEnd) {
      this.userdataModel.setBookmarkLetter(this.currentChunkEnd);
      this.bookmarkLetterAtGameBegin=this.currentChunkEnd;
      this.currentBookmarkLetter=this.currentChunkStart;
    }
    //console.log("AFT fitBookmark bookmarkLetterAtGameBegin"+this.bookmarkLetterAtGameBegin+" currentBookmarkLetter"+this.currentBookmarkLetter);
  }

  begingame(){
    this.currentGuessableString="";
    this.textblocks=[];
    this.lettersGuessedOrNotHangman=[];
    this.maxAttemptsWrong=[];
    this.maxAttemptsTotal=[];
    this.finalEntropyValues=[-1,-1];
    this.pauseInteractionWithKeyboard=false;
    this.isGameEndedBoolean=false;
    this.currentKeyboard=0;
    this.tutorialIsRunning=false;
    //this.setShiftStatus(false);
    this.resetLetterTried();
    this.functions.getGameMode();
    this.functions.getDifficulty();
    this.functions.getLanguage();
    this.fartherIndexDashReachedDuringGame=-1;
    this.wasGameModeVersus=false;
    this.initialBonusGave=false;
    
    this.round=0;
    this.attempt=1;
    this.scorePartial=0;
    this.scoreFinalAI=0;

    this.currentThermometerProgress=100;

    this.bookmarkAtGameBegin=this.userdataModel.getBookmark();
    this.bookmarkLetterAtGameBegin=this.userdataModel.getBookmarkLetter();
    this.chunkCharSkippedAtBeginningOrEndOfBook=0;
    this.numChunksInBook=this.gamesrulesModel.getNumChunksOfBook(this.functions.getIdCurrentBook());
    
    // TODO in versus the first 4 games simply are not chosen to avoid this problem
    if (!this.functions.isGameModeVersus()) {
      this.skipChunkIfNotEnoughTextToShowForPriorOrPosterior();   
      // Update variable about chunk and If the bookmark is not inside chunk, normalize situation. 
      // This normally happens if chunks are not contiguos or when the chunk has been modified by skipChunkIfNotEnoughTextToShowForPriorOrPosterior
      this.updateChunkVarsForChunk(this.currentChunk);
      this.getSingleGameAIdataToCompare("lstm4x512+wlsm_1.0.0",this.functions.getIdCurrentBook(),this.currentChunkStart);
    }

    this.currentBookmarkLetter=this.userdataModel.getBookmarkLetter();
    this.currentBookmark=this.userdataModel.getBookmark();

    this.instext = ''; 
    this.mood='happy';
    this.numSbagliate=0;
    this.numCorrette=0;
    this.currentColorCatVersus="none";
    
    if (this.functions.isGameModeVersus()) {
      this.time=0;
      this.currentChunkScoreAtGameBegin=0;
      this.numLettersGuessedInCurrentChunkAtGameBegin=0;
    }else{
      this.time=this.userdataModel.getCurrentTime();//this.functions.getGameTimeAvailableAtCurrentDifficulty();
      this.currentChunkScoreAtGameBegin=this.userdataModel.getCurrentChunkScore();
      this.numLettersGuessedInCurrentChunkAtGameBegin=this.userdataModel.getCurrentNumLettersGuessedInCurrentChunk();
    }
    
    this.currentLevel=this.userdataModel.getLevel();
    this.currentLevelProgress=this.gamesrulesModel.getProgressInLevelFromScore(this.userdataModel.getScore());
    this.timeFinal=-1;

    this.initializeGameModeVersus().then((response)=>{
      this.checkBootstrapBookmark(); // only for shannon mode
      this.http.get('assets/data/book_'+this.functions.getIdCurrentBook()+'.txt').subscribe(data=>{
        let obj = data['_body'];
        
        this.updateIndexesAndBookmark(false);
        this.splitText(obj).then((response)=>{
          this.updateIndexesAndBookmark(false);

          // this must be done here in order to have indexElementToGuess properly set
          if (this.functions.isGameModeShannon()) { this.updateArrayLetterTriedHangman();  } 
    
          this.updateCurrentChunkProgress();

          this.updateThermometer(this.currentBookmarkLetter);
    
          console.log("--------GAME SETTINGS--------"+ " Gamemode: "+this.functions.gamemode+"  Guid User: "+this.userdataModel.getGuidUser()+"  Book:"+this.functions.getIdCurrentBook()+"  Lang: "+this.functions.language+"  #Letter GuessSim: "+this.functions.numLetterGuessableSimul[this.functions.gamemode]+"  #Letter In Game: "+this.functions.numLetterToConsiderInASingleGame+"  #Prior/Posterior: "+this.functions.numCharacterPriorOrPosterior+"  ("+JSON.stringify(this.priorOrPosteriorIndexes)+")"+"  Versus: "+this.functions.isGameModeVersus()+"  Vs User: "+ this.guidUserVersus+"  Game: "+this.idGameVersus+" ----------------");
            
          this.playModel.addGame(
            this.userdataModel.getGuidUser(),               //guidUser
            this.playModel.getNewGameId(),                  //idGame
            this.functions.getIdCurrentBook(),              //idBook
            this.functions.getCurrentDevice(),              //currentDevice
            this.functions.numSentenceToGuessInOneRound,    //numSntToGuess
            this.functions.numLetterGuessableSimul[this.functions.gamemode], //numLetterGuessableSimul
            this.functions.numCharacterPriorOrPosterior,    //numCharacterPriorOrPosterior
            this.functions.coefficentGoAheadOnCutBook,      //coefficentGoAheadOnCutBook
            this.functions.numLetterToConsiderInASingleGame,//numLetterToConsiderInASingleGame
            JSON.stringify(this.functions.booksPlayable),   //booksPlayable
            JSON.stringify(this.functions.booksPlayableInVersus),           //booksPlayableInVersus
            JSON.stringify(this.keyboards[this.functions.language]),        //keyboards
            this.functions.currentTimestamp(),              //tsTegingame
            -1,                                             //tsTndgame
            this.functions.difficulty,                      //difficulty
            this.functions.gamemode,                        //gamemode
            this.functions.language,                        //language
            this.userdataModel.getScore(),                  //scoreInitial
            -1,                                             //scoreFinal
            this.gamesrulesModel.getParVersion(),           //parVersion
            this.userdataModel.getSkip(),                   //skipInitial
            -1,                                             //skipFinal
            this.userdataModel.getBookmark(),               //bookmarkInitial
            -1,                                             //bookmarkFinal
            this.bookmarkLetterAtGameBegin,                 //bookmarkLetterInitial
            -1,                                             //bookmarkLetterFinal
            this.currentChunk,                              //idChunkInBookInitial
            -1,                                             //idChunkInBookFinal
            this.userdataModel.getLevel(),                  //levelInitial
            -1,                                             //levelFinal
            this.fartherIndexDashReachedDuringGame,         //fartherIndexDashReachedDuringGame
            this.numCorrette,                               //numCorrette
            this.numSbagliate,                              //numSbagliate
            JSON.stringify(this.getBookmarkFromIndexInSlicedArray(this.priorOrPosteriorIndexes[0])+","+this.getBookmarkFromIndexInSlicedArray(this.priorOrPosteriorIndexes[1])),   //priorOrPosteriorIndexes
            false,                                          //giveup
            false,                                          //typeOfwin
            this.guidUserVersus,                            //guidUserVersus
            this.idGameVersus,                              //idGameVersus
            -1,                                             //timeFinal
            []                                              //wordstyped
          );  

          if (!this.functions.isGameModeVersus()){
            this.timer();
          }else{
            this.updateCurrentGuessableString();
          }
        });
      });
    });
  }

  initializeGameModeVersus(){
    // TODO now this works with AI games. This must be optimized for versus player that could be 
    // simple as can data passed in this function getSingleGameDataVersus
    // here must be inserted player you do want to play with and add guidUser and idGame to addGame data

    //this.guidUserVersus="b38fbe53c5cb1";
    //this.idGameVersus=this.functions.idGameVersusChosenDev;//"179"; 
    
    return new Promise((resolve) =>{
      if (this.functions.isGameModeVersus()) {
        // ------ Getting opponent game ------ //
        this.opponentCurrentAttempt=1;
        this.currentScoreAi=0;
        //guidUser,idGame,idBook,gamemode,language,opponentIsAI
        //this.getSingleGameDataVersus("","","20",this.functions.gamemode,this.functions.language)
        this.currentColorCatVersus="none";
        this.getSingleGameDataVersus("lstm4x512+wlsm_1.0.0","",this.chooseBookVersus(),"",this.functions.language,true).then((response)=>{
          /* This syncronize game to book and bookmark of the playback game. */
          if (this.initialGameDataForVersus.length<=0) { console.log("ERROR: Game not found!");}

          //console.log("XXXXXXX book: "+this.initialGameDataForVersus[0].idBook+" bookmark: "+this.bookmarkLetterAtGameBegin+" book id: "+this.functions.getIdCurrentBook());
          //console.log("XXXXXXX this.initialGameDataForVersus[0]: "+JSON.stringify(this.initialGameDataForVersus[0]));
          
          // ------ Initializing gamemode ------ //
          this.changeSettingsBeforeGameVersus();

          this.wasGameModeVersus=true;
          this.guidUserVersus=this.initialGameDataForVersus[0].guidUser;
          this.idGameVersus=this.initialGameDataForVersus[0].idGame;
          this.scoreFinalAI=this.initialGameDataForVersus[0].scoreFinal;
          this.entropyFinalAI=this.functions.roundTwoDecimal(this.initialGameDataForVersus[0].up_entropy);
    
          // ------ Initialize Array of opponent game ------//

          var tsInsertBefore;
          var tsBegingame;
          var intervalBefore;
          this.opponentGameDataVersus=[];
          //console.log("this.initialGameDataForVersus[0]: "+JSON.stringify(this.initialGameDataForVersus[0]));  
          //console.log("this.initialGameDataForVersus[0].wordstyped: "+JSON.stringify(this.initialGameDataForVersus[0].wordstyped));
          
          /* TODO Here for player versus is 
              tsBegingame=this.convertTimestamp(this.initialGameDataForVersus[0].tsBegingame);
            for the ts is a timestamp */
          tsBegingame=this.initialGameDataForVersus[0].tsBegingame;
          tsInsertBefore=tsBegingame;
          intervalBefore=0;
          this.minBookmarkReachedOpponent=Infinity;
          this.maxBookmarkReachedOpponent=-1;
    
          for (let j = 0; j < this.initialGameDataForVersus[0].wordstyped.length; j++){
            //console.log("XXXXXXX interval: "+((this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore));
            //console.log("XXXXXXX intervalBefore: "+intervalBefore);
            //console.log("XXXXXXX time: "+((this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore+intervalBefore));
            //console.log("XXXXXXX bookmarkLetter:"+this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter);

            /* TODO Here for player versus is 
                time: this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore+intervalBefore,
            for the ts is a timestamp */
            this.opponentGameDataVersus.push({
              time: this.initialGameDataForVersus[0].wordstyped[j].tsInsert-tsInsertBefore+intervalBefore,
              bookmarkLetter: this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter,
              isCorrect: this.initialGameDataForVersus[0].wordstyped[j].isCorrect,
              attempt: this.initialGameDataForVersus[0].wordstyped[j].attempt
            });
             /* TODO Here for player versus is 
                  intervalBefore+=(this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert)-tsInsertBefore);
                tsInsertBefore=this.convertTimestamp(this.initialGameDataForVersus[0].wordstyped[j].tsInsert);
              for the ts is a timestamp */
            intervalBefore+=(this.initialGameDataForVersus[0].wordstyped[j].tsInsert-tsInsertBefore);
            tsInsertBefore=this.initialGameDataForVersus[0].wordstyped[j].tsInsert;
    
            if (this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter<this.minBookmarkReachedOpponent) {
              this.minBookmarkReachedOpponent=this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter;
            }
            if (this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter>this.maxBookmarkReachedOpponent) {
              this.maxBookmarkReachedOpponent=this.initialGameDataForVersus[0].wordstyped[j].bookmarkLetter;
            }
          }
          //console.log("XXXXXXX this.opponentGameDataVersus: "+JSON.stringify(this.opponentGameDataVersus));
          //console.log("XXXXXXX bookmark reached MIN: "+this.minBookmarkReachedOpponent+" MAX: "+this.maxBookmarkReachedOpponent);
    
          /*var counter = 10;
          var myFunction = function() {
            console.log("counter:"+counter);
            counter *= 10;
            setTimeout(myFunction, counter);
          }
          setTimeout(myFunction, counter);*/

          // In hangman mode game you can skip so the first bookmark of a game could not be the first of the game array
          // but the min bookmark reached in the opponent game
          this.bookmarkLetterAtGameBegin=this.minBookmarkReachedOpponent;
          this.updateChunkVarsForChunk(this.gamesrulesModel.getChunkFromBookmarkLetter(this.functions.getIdCurrentBook(),this.bookmarkLetterAtGameBegin));

          this.timerVersus();
          resolve("initializeGameModeVersusisOK");          
        });
      }else{
        this.guidUserVersus="";
        this.idGameVersus="";
        resolve("initializeGameModeVersusisOK");
      }
    });
  }

  updateScoreForOpponentGameDataVersus(){
    //attempt
    var attemptsWrongAItmp=0;
    var scoreAItmp=0;

    //console.log("XXXXXXX BEF opponentGameDataVersus:"+JSON.stringify(this.opponentGameDataVersus));
    for (let i = 0; i < this.opponentGameDataVersus.length; i++){
      if (!this.opponentGameDataVersus[i].isCorrect) {
        this.opponentGameDataVersus[i].score=scoreAItmp;
        attemptsWrongAItmp++;
      }else{
        scoreAItmp=scoreAItmp+this.gamesrulesModel.calculateScore(
          attemptsWrongAItmp+1,
          this.getParOfBookmark(this.opponentGameDataVersus[i].bookmarkLetter));  
        this.opponentGameDataVersus[i].score=scoreAItmp;
        attemptsWrongAItmp=0;
      } 
    }
    //console.log("XXXXXXX AFT opponentGameDataVersus:"+JSON.stringify(this.opponentGameDataVersus));
  }

  changeRound(){
    this.round++;
    this.resetLetterTried();
    this.updateIndexesAndBookmark(false);

    this.updateCurrentGuessableString();
    
    if(this.isGameEnded()){
      this.instext='';
      this.endgame("end_classic");
    }
  }

  scrollOnFocusText(){
    if (document.getElementById("blinking_underscore_id")) { // otherwise this could be called before the screen was drawed (during ionViewWillEnter)
      var offsetBlinkingUnderscore=document.getElementById("blinking_underscore_id").offsetTop;
      this.scrollElement = this.showntextscroll.nativeElement;
      
      /*console.log("scroll");
      console.log("Height: "+this.scrollElement.scrollHeight);
      console.log("Top: "+this.showntextscroll.nativeElement.scrollTop);
      console.log("offsetBlinkingUnderscore: "+offsetBlinkingUnderscore);*/

      if (offsetBlinkingUnderscore<=0) {
        this.scrollElement.scrollTop = 0;
      }else{
        if (this.functions.isVizMobile()) {
          this.scrollElement.scrollTop = offsetBlinkingUnderscore-50;
        }else{
          this.scrollElement.scrollTop = offsetBlinkingUnderscore-150;
        }
      }
    }
  }

  keyPressed(keyChosen,source){
    /* keyChosen here could be:
    - phisical keyboard: (string) event.key i.e. textual descriptor of the button pressed (including things like Shift etc)
    - ingame keyboard: (number) index of the button on the current keyboard, 33 for spacebar, Shift, changekeyboard, Backspace, ArrowLeft, ArrowRight
    */

   //console.log("Key pressed: "+keyChosen+" from source: "+source);

    var indexKeyChosen;

    var isSpecialKey=false;
    if(keyChosen=='Shift' || keyChosen=='Backspace' 
    || keyChosen=='Enter' || keyChosen=='changekeyboard' 
    || keyChosen=='ArrowLeft' || keyChosen=='ArrowRight' ){
      isSpecialKey=true;
    }

    if (source=='ingamekeyboard' && !isSpecialKey) {
      indexKeyChosen=keyChosen;
      keyChosen=this.keyboards[this.functions.language][this.currentKeyboard][keyChosen];
    }

    // From here on, keyChosen is the letter pressed
    //console.log("Real Key pressed: "+keyChosen+" from source: "+source);

    /* Blocking key pressed on phisical keyboard if
    - they are not on game keyboard 
    - they are not special key
    - they are not uppercase letter (uppercase are accepted anyway not to disappoint pc user not able to use uppercase letters)
    */
    if (source=='phisicalkeyboard') {
      if (
        !this.isAvailableOnIngameKeyboardKey(keyChosen) 
        && !isSpecialKey 
        && !this.functions.isLetterUppercase(keyChosen)
      ) {
        console.log("Key blocked!");
        return;
      }
      indexKeyChosen=this.getIndexInKeyboards(keyChosen, "currentKeyboard","returnSingleIndex","changeKeyboardWithIndexFound");
    }

    if(keyChosen=='Shift'){
      // Shift is unesuful now due to the game become insensitive
      //this.shiftSwitch();
    }

    if(keyChosen=='ArrowLeft' && this.functions.isGameModeShannonHangman() && !this.functions.isGameModeVersus()){
      this.moveCursor("left");
    }

    
    if(keyChosen=='ArrowRight' && this.functions.isGameModeShannonHangman()&& !this.functions.isGameModeVersus()){
      this.moveCursor("right");
    }
    
    if(keyChosen=='Backspace'){
      this.instext=this.instext.substring(0, this.instext.length - 1);
    }

    if(keyChosen=='Enter'){
      if(this.instext!=""){
        this.tryWord();
      }
    }

    if(keyChosen=='changekeyboard'){
      this.changeKeyboard()
    }

    if(!isSpecialKey){
      keyChosen=this.functions.normalizeWordForComparison(keyChosen);
      if(this.functions.isGameModeShannon() && !this.isLetterTried(indexKeyChosen)){
        this.instext=keyChosen;
        // In Shannon mode any character you write is tried to guess
        this.tryWord();
      }else{
        if(this.isAvailableOnIngameKeyboardKey(keyChosen)){
          this.instext+=keyChosen;
        }          
      }
    }
    if(!isSpecialKey){
      this.animateButtonClicked("key_"+indexKeyChosen,'colorgrey');
    }else{
      this.animateButtonClicked(keyChosen,'colorgrey');
    }
  }

  animateButtonClicked(buttonId,classToAdd){
    //console.log("animateButtonClicked buttonId:"+buttonId);
    if(document.getElementById(buttonId)){
      document.getElementById(buttonId).classList.add(classToAdd);
      var clickAnimationIntervalId = setInterval(function(){document.getElementById(buttonId).classList.remove(classToAdd); clearInterval(clickAnimationIntervalId); clearInterval(this.clickAnimationIntervalId);},300);
      document.getElementById(buttonId).blur();
    }else{
      console.log("ERROR: Button Id not available for animation!");
    }
  }

  handleKeyboardEventsKeyDown(event: KeyboardEvent) {
    //console.log("Key Down: "+event.key);
    if(this.navCtrl.getActive().name=="PlayPage" && !this.pauseInteractionWithKeyboard){      
      // this avoid enter and space to add extra character after a button is used and so focused
      event.preventDefault();
      event.stopPropagation();

      // In Shannon Mode this avoid you to try more than one time the same letter
      if(!this.functions.isGameModeShannon() ||
        (this.functions.isGameModeShannon() && !this.isLetterTried(this.getIndexInKeyboards(event.key,"allKeyboards","returnSingleIndex","changeKeyboardWithIndexFound")))){
          this.keyPressed(event.key,'phisicalkeyboard');
      }   

      // Shift is currently disabled
      /*if(event.key=="Shift"){
        this.setShiftStatus(true);
      } */ 

      this.scrollOnFocusText(); 
    }
  }

  handleKeyboardEventsKeyUp(event: KeyboardEvent) {
    //console.log("Key up: "+event.key);
    if(this.navCtrl.getActive().name=="PlayPage" && !this.pauseInteractionWithKeyboard){      
      // this avoid enter and space to add extra character after a button is used and so focused
      event.preventDefault();
      event.stopPropagation();
      this.scrollOnFocusText();

      // Shift is currently disabled
      /*
      if(event.key=="Shift"){
        this.setShiftStatus(false);
      } */     
    }
  }

  keyIsDisabled(key){
    // NOTE: THIS IS NOT used currently
    var keyIndexOnKeyboard = this.getIndexInKeyboards(key, "allKeyboards","returnSingleIndex","changeKeyboardWithIndexFound");
    if(keyIndexOnKeyboard>0){
      if((<HTMLInputElement> document.getElementById("key_"+keyIndexOnKeyboard)).disabled){
        return true;
      };
    }
    return false;
  }

  isAvailableOnIngameKeyboardKey(keyChosen) {
    if (this.getIndexInKeyboards(keyChosen, "allKeyboards","returnSingleIndex","changeKeyboardWithIndexFound")>=0) {
      return true;
    }else{
      return false;
    }
  }

  /* NOTE: Shift is disabled so this is not used currently */ 
  /*setShiftStatus(status){
    if(this.functions.isGameModeShannon()){
      this.shiftOn=status;
      this.switchKeyboardForShift();
    }
  }

  shiftSwitch(){
    if(this.functions.isGameModeShannon()){
      if (this.shiftOn==true) {
        this.shiftOn=false;
      }else{
        this.shiftOn=true;
      }
      this.switchKeyboardForShift();
    }
  }

  switchKeyboardForShift(){
    if (this.shiftOn && this.currentKeyboard==1) {
      this.currentKeyboard=0;
    }
    if (!this.shiftOn && this.currentKeyboard==0) {
      this.currentKeyboard=1;
    }
  }*/
  /* ----------------------------------------------------- */ 

  changeKeyboard(){
    /*
    // NOTE: This is old code used for managing the Shift key
    if (this.currentKeyboard==0) {
      this.changeKeyboardToNum(2);
    }else{
      if ((this.currentKeyboard+1)>=this.numKeyboardsAvailable) {
        if(this.shiftOn){ this.changeKeyboardToNum(0); }
        if(!this.shiftOn){ this.changeKeyboardToNum(1); }
      }else{
        this.changeKeyboardToNum(this.currentKeyboard+1);;
      }
    }*/

    if ((this.currentKeyboard+1)>=this.numKeyboardsAvailable) {
      this.changeKeyboardToNum(0);
    }else{
      this.changeKeyboardToNum(this.currentKeyboard+1);;
    }
  }

  changeKeyboardToNum(numkeyboard){
    /*if (numkeyboard<0 || numkeyboard>=this.numKeyboardsAvailable) {
      if(this.shiftOn){ this.currentKeyboard=0; }
      if(!this.shiftOn){ this.currentKeyboard=1; }
    }else{
      if (numkeyboard==0) { this.shiftOn=true; }
      if (numkeyboard==1) { this.shiftOn=false; }
      this.currentKeyboard=numkeyboard;
    }*/
    this.currentKeyboard=numkeyboard;
  }

  setKeyboardsSizes(){
    var count = 0;

    for (var k in this.keyboards[this.functions.language]) if (this.keyboards[this.functions.language].hasOwnProperty(k)) { ++count; };

    this.numKeyboardsAvailable=count;
    this.numLettersInSingleKeyboards=this.keyboards[this.functions.language][0].length;
  }

  getIndexInKeyboards(letter, allOrCurrentKeyboard, returnSingleOrAllIndexes, changeKeyboardWithIndexFound){
    var indexesFound=[];
    var indexLetter=-1;
    var indexKeyboard=-1;

    //console.log("+++++ letter to search: "+JSON.stringify(letter));

    // It could be found the same key in more than one keyboard
    for (var i=0; i < this.numKeyboardsAvailable; i++) { // for each keyboard
      for (var j = 0; j < this.keyboards[this.functions.language][i].length; j++) { // for each element in keyboard
        if ((allOrCurrentKeyboard=="currentKeyboard" && i==this.currentKeyboard)
        || allOrCurrentKeyboard=="allKeyboards") {
          if (this.keyboards[this.functions.language][i][j] == letter) {
            indexesFound.push([i,j]);
          }  
        } 
      }
    }

    //console.log("+++++ indexes found: "+JSON.stringify(indexesFound));

    // if the key is in the current keyboard that is put in first position in array indexes found
    for (var x=0; x < indexesFound.length; x++) {
      if (indexesFound[x][0]==this.currentKeyboard) {
        indexesFound=this.functions.array_move(indexesFound, x, 0)
        //console.log("+++++ indexes found AFT MOVE: "+JSON.stringify(indexesFound)); 
      }
    }

    // the first found is selected wheter is the unique or moved there for it is the one on the current keyboard
    if (indexesFound.length>0) {
      indexKeyboard=indexesFound[0][0];
      indexLetter=indexesFound[0][1];
    }

    //console.log("indexLetter found: "+JSON.stringify(indexLetter));
    //console.log("indexKeyboard found: "+JSON.stringify(indexKeyboard));
    //console.log("this.currentKeyboard: "+JSON.stringify(this.currentKeyboard));

    if (indexKeyboard!=this.currentKeyboard 
      && indexKeyboard!=-1
      && changeKeyboardWithIndexFound=="changeKeyboardWithIndexFound") {
      this.changeKeyboardToNum(indexKeyboard);
    }

    if (returnSingleOrAllIndexes=="returnAllIndexes") {
      return indexesFound;
    }else{ // is "returnSingleIndex" and all error situations
      return indexLetter;
    }
  }

  /**
   * In slicedTextblock you'll typical have segments of multiple chunks: the current one completely
   * and part of the next or the previous just to have text to fill prior or posterior
   * This functions gets the index [i,j] where i it's the start index in slicedTextblock of the current chunk
   * and j is the end index of the current chunk
   */
  getBoundariesOfCurrentChunkInSlicedArray(){
    var currentChunkStartInSlicedArray=this.getIndexInSlicedArray(this.currentChunkStart);
    var currentChunkEndInSlicedArray=this.getIndexInSlicedArray(this.currentChunkEnd);
    return [currentChunkStartInSlicedArray,currentChunkEndInSlicedArray];
  }

  updateCurrentChunkProgress(){
      var numPriorOrPosteriorGifted=0;
      if (this.currentChunk==0 || this.currentChunk==(this.userdataModel.getNumchunktotalOfBook(this.functions.getIdCurrentBook())-1)) {
        numPriorOrPosteriorGifted=this.functions.numCharacterPriorOrPosterior;
      }
      
      if (this.chunkCharSkippedAtBeginningOrEndOfBook!=0) {
        numPriorOrPosteriorGifted=this.chunkCharSkippedAtBeginningOrEndOfBook;
        console.log("chunkCharSkippedAtBeginningOrEndOfBook: "+this.chunkCharSkippedAtBeginningOrEndOfBook);
      }

      if (numPriorOrPosteriorGifted>0 && this.currentChunkScoreAtGameBegin==0 && !this.initialBonusGave && !this.functions.isGameModeVersus()) {
        console.log("BEF scorePartial:"+this.scorePartial);
        this.scorePartial=this.scorePartial+(this.functions.numCharacterPriorOrPosterior*200);
        this.initialBonusGave=true;
        console.log("points gifted: "+(this.functions.numCharacterPriorOrPosterior*200)+" AFT scorePartial:"+this.scorePartial);
      }

      this.currentChunkProgress=this.functions.calculatePercentage((this.numLettersGuessedInCurrentChunkAtGameBegin+numPriorOrPosteriorGifted+this.numCorrette),this.currentChunkTotalChar,"progress in chunk");
      //progress=Math.round(((this.numLettersGuessedInCurrentChunkAtGameBegin+numPriorOrPosteriorGifted+this.numCorrette)/this.currentChunkTotalChar)*100);
  }
  
  /* --------- END FUNCTIONS --------- */

  /* --------- FUNCTIONS GAME BOTH MODE --------- */
  
  updateIndexesAndBookmark(isLastRound){
    if (this.functions.isGameModeShannon()) {
      this.updateIndexesAndBookmark_shannon(isLastRound);
    }else{
      this.updateIndexesAndBookmark_classic(isLastRound);
    }
  }

  splitText(textblockToSplit){
    return new Promise((resolve) =>{
      if (this.functions.isGameModeShannon()) {
        this.splitText_shannon(textblockToSplit).then((response)=>{
          resolve("splitTextIsOk");
        });
      }else{
        this.splitText_classic(textblockToSplit);
        resolve("splitTextIsOk");
      }
    });
  }

  isGameEnded(){
    var end:boolean;
    if (this.functions.isGameModeShannon()) {
      end=this.isGameEnded_shannon();
    }else{
      end=this.isGameEnded_classic();
    }
    return end;
  }

  getElementToGuess(){
    var index=this.indexCurrentElementToGuessInTextblockWithMode();
    if (!this.functions.isGameModeShannon()) {
      return this.textblocks[index].wordToGuess;
    }
    if (this.functions.isGameModeShannon()) {
      return this.textblocks[index].slicedTextblock.substring(this.indexElementToGuessInThisRound,this.indexElementToGuessInThisRound+1);
    } 
  }

  startTutorial(){
    this.intro(); // tutorial intro.js. If put in 
  }

  calculateFinalEntropyOfChunk(idChunkInBookAtGameEnd){
    return new Promise((resolve) =>{
      this.getMaxAttemptsTotal(this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),idChunkInBookAtGameEnd),this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),idChunkInBookAtGameEnd)).then((response)=>{
        var attemptsTotalInChunk=[]; // freed of zero values
        var j=0;
    
        // remove zero values
        for (let i = 0; i < this.maxAttemptsTotal.length; i++) {
          if (this.maxAttemptsTotal[i]!=0) {
            attemptsTotalInChunk[j]=this.maxAttemptsTotal[i];
            j++;
          }      
        }
        this.finalEntropyValues=[this.functions.roundTwoDecimal(this.functions.down_entro(attemptsTotalInChunk)),this.functions.roundTwoDecimal(this.functions.up_entro(attemptsTotalInChunk))];

        console.log("Up Entro: "+this.functions.up_entro(attemptsTotalInChunk)+"  Down Entro: "+this.functions.down_entro(attemptsTotalInChunk)+"  attemptsTotalInChunk: "+JSON.stringify(attemptsTotalInChunk));
        resolve("calculateFinalEntropyOfChunkIsOk"); 
      });
    });
  }

  // Generate array with attempt total (wrong+1 if correct)
  getMaxAttemptsTotal(startBookmark,endBookmark){
    var maxAttemptsTotal=[];
    //console.log("+++++ this.maxAttemptsWrong: "+JSON.stringify(this.maxAttemptsWrong));

    return new Promise((resolve) =>{

      this.dataExchanger.getMaxAttemptsWrongFromServer(startBookmark,endBookmark).then((maxAttemptsWrongJson)=>{
        //console.log("+++++++ getMaxAttemptsWrongFromServer: "+JSON.stringify(maxAttemptsWrongJson));
          var i=0;
          for (var attempt in maxAttemptsWrongJson){ // this is strange, any other way the compiler doesn't accept it
            maxAttemptsTotal[i] = maxAttemptsWrongJson[attempt].attemptsWrong;
            if (maxAttemptsWrongJson[attempt].isCorrect) {
              maxAttemptsTotal[i]++;
            }
            i++;
          }
          
          //console.log("+++++ maxAttemptsTotal: "+JSON.stringify(maxAttemptsTotal));
          this.maxAttemptsTotal=maxAttemptsTotal;
          resolve();
      });
    });
  }

  updateChunkVarsForChunk(idChunkInBook){
    this.currentChunk=idChunkInBook;
    this.currentChunkStart=this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),this.currentChunk);
    this.currentChunkEnd=this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),this.currentChunk);
    // Bookmark starts from 0 and that's why +1
    this.currentChunkTotalChar=(this.currentChunkEnd-this.currentChunkStart)+1;

    this.fitBookmarkInsideChunk();
  }

  /* --------- FUNCTIONS GAME MODE CLASSIC --------- */
  splitText_classic(textblockToSplit) {
    this.splitInSntTotal=[];
    this.splitInSnt=[];

    this.numSntToSkipInThisRound=0;
    this.indexElementToGuessInThisRound=0;
    
    // Split the whole text of the book in sentences
    this.splitInSntTotal=this.functions.splitInSentences(textblockToSplit);

    // Get the total number of sentence in this story
    this.numSntTotalBook=this.splitInSntTotal.length;
    this.userdataModel.setNumsnttotal(this.numSntTotalBook);

    // Cut the book to use only a  reasonable amount of sentence to play
    this.cutBookForPlaying();

    this.textblocks=this.functions.getArrayTextblocksForPlaying(this.splitInSnt, this.userdataModel.getBookmark(), this.userdataModel.getBookmarkLetter(), this.functions.getIdCurrentBook(),0,0);

    this.numSntToSkipInThisRound=this.getTotalNumBlocksToSkipInThisGame();
    this.indexElementToGuessInThisRound=this.getNumBlocksToSkipAfterThisBookmark(0);

    // Get only the blocks necessary for this game
    // NB: Maybe in the last round we have less sentence available than numSentenceToGuessInOneRound
    this.lastSntToConsiderIndex=/*tmpBookmark+*/this.functions.numSentenceToGuessInOneRound+this.numSntToSkipInThisRound;
    if(this.numSntTotalBook<this.lastSntToConsiderIndex){
      this.lastSntToConsiderIndex=this.numSntTotalBook;
    }
    
    this.textblocks=this.textblocks.slice(0, this.lastSntToConsiderIndex);
    this.numElementsToPlay=this.textblocks.length;
    
    return;              
  }

  cutBookForPlaying(){
    /* NB: This avoid splitting totally a book and slowing the game. It will be considered only element between current bookmark
     and the coefficent times the necessary blocks (which must be a good compromise to skip bad sentence eventually)*/
    if( (this.splitInSntTotal.length-this.currentBookmark) > (this.functions.numSentenceToGuessInOneRound*this.functions.coefficentGoAheadOnCutBook) ){
      this.splitInSnt=this.splitInSntTotal.slice(this.currentBookmark,(this.functions.numSentenceToGuessInOneRound*this.functions.coefficentGoAheadOnCutBook)+this.currentBookmark);
    }else{
      this.splitInSnt=this.splitInSntTotal.slice(this.currentBookmark); // take it all from the bookmark to the end 
    }
  }
  
  getNumBlocksToSkipAfterThisBookmark(bookmark){
    var textblockLength=this.textblocks.length;
    var numSentenceLooped=bookmark;
    var numSntToSkip=0;

    while(numSentenceLooped<(textblockLength) ){
      if(this.textblocks[numSentenceLooped].skipThisBlock==1){
        numSntToSkip++;
      }else{
        break;
      }
      numSentenceLooped++;
    }
    //console.log("++++++ After bookmark "+bookmark+" textblockLength"+textblockLength+" numSentenceLooped:"+numSentenceLooped+" numSntToSkip:"+numSntToSkip);  
    return numSntToSkip;
  }

  getTotalNumBlocksToSkipInThisGame(){
    var textblockLength=this.textblocks.length;
    var numSentenceLooped=0;
    var numSntToSkip=0;
    var numSntToConsider=0;
    while(numSntToConsider<=this.functions.numSentenceToGuessInOneRound && numSentenceLooped<(textblockLength) ){
      if(this.textblocks[numSentenceLooped].skipThisBlock==1){
        numSntToSkip++;
      }else{
        numSntToConsider++;
      }
      numSentenceLooped++;
    }
    //console.log("++++++ textblockLength:"+textblockLength+" numSntToConsider:"+numSntToConsider+" numSentenceLooped:"+numSentenceLooped+" numSntToSkip:"+numSntToSkip);  
    return numSntToSkip;
  }

  updateIndexesAndBookmark_classic(isLastRound){
    console.log("--------UPDATE INDEXES--------");
    console.log("BEF indexElementToGuessInThisRound: "+this.indexElementToGuessInThisRound);
    console.log("BEF currentBookmark:"+this.currentBookmark+" currentBookmarkLetter:"+this.currentBookmarkLetter);
    console.log("ROUND:"+this.round+" and numElementsToPlay:"+this.numElementsToPlay);
 
    if(this.round!=0 && !isLastRound){
      this.indexElementToGuessInThisRound++; // +1 for the round increasing
    }
  
    this.numSntToSkipInThisRound=this.getNumBlocksToSkipAfterThisBookmark(this.indexElementToGuessInThisRound);
    this.indexElementToGuessInThisRound+=this.numSntToSkipInThisRound;
  
    if(this.round==0){
      this.currentBookmark=this.userdataModel.getBookmark();
      this.currentBookmarkLetter=this.indexElementToGuessInThisRound;
      if(this.indexElementToGuessInThisRound>this.userdataModel.getBookmarkLetter()){
        this.currentBookmarkLetter=this.indexElementToGuessInThisRound;
      }else{
        this.currentBookmarkLetter=this.userdataModel.getBookmarkLetter();
      }
  
      this.checkInitialBookmarks();
    }else{
      this.currentBookmark=this.userdataModel.getBookmark()+this.indexElementToGuessInThisRound;
      this.currentBookmarkLetter=0;
        
      if(isLastRound){
        if(this.currentBookmarkLetter>=this.numElementsToPlay){
          this.numElementsToPlay=0;
          this.currentBookmarkLetter=0;
          this.currentBookmark=this.userdataModel.getBookmark()+1;
        }
      }
    }  
    
    console.log("AFT indexElementToGuessInThisRound: "+this.indexElementToGuessInThisRound);
    console.log("AFT currentBookmark:"+this.currentBookmark+" currentBookmarkLetter:"+this.currentBookmarkLetter);
    if(this.indexElementToGuessInThisRound<this.textblocks.length){
      console.log("BEGINNING: "+this.textblocks[this.indexElementToGuessInThisRound].beginning);
      console.log("WORD TO GUESS : "+this.textblocks[this.indexElementToGuessInThisRound].wordToGuess);  
      console.log("ENDING: "+this.textblocks[this.indexElementToGuessInThisRound].ending); 
    }
    console.log("----------------");
  }

  // Fallback: if indexElementToGuessInThisRound is over the allowed, go to next sentence
  checkInitialBookmarks(){
    if(this.currentBookmark){
      if(this.currentBookmarkLetter){
        if(this.numElementsToPlay){
          // TODO farlo anche per gamemode Shannon?
          if(!this.functions.isGameModeShannon() && this.indexElementToGuessInThisRound>=this.numElementsToPlay){
            console.log("Emergency Reset! Bookmark out of boudaries.");
            console.log("currentBookmark: "+this.currentBookmark);
            console.log("currentBookmarkLetter: "+this.currentBookmarkLetter);
            console.log("numElementsToPlay: "+this.numElementsToPlay);
            console.log("indexElementToGuessInThisRound: "+this.indexElementToGuessInThisRound);
            
            if((this.currentBookmark+1)<this.userdataModel.getNumsnttotal()){
              this.currentBookmark++;
              this.currentBookmarkLetter=0;
            }else{
              this.currentBookmarkLetter=0;
            }
            
            if(this.functions.isGameModeShannon()){
              this.indexElementToGuessInThisRound=0;
            }
            if(!this.functions.isGameModeShannon()){
              this.indexElementToGuessInThisRound=this.getNumBlocksToSkipAfterThisBookmark(0);
            }
          }
        
        }
      }  
    }
  }

  isGameEnded_classic(){
    if(this.indexElementToGuessInThisRound<this.numElementsToPlay){ 
      return false;
    }
    if(this.indexElementToGuessInThisRound>=this.numElementsToPlay){
      return true;
    }
  }

  /* --------- FUNCTIONS GAME MODE SHANNON --------- */

  splitText_shannon(textblockToSplit) {
    return new Promise((resolve) =>{
      this.indexElementToGuessInThisRound=0;

      // TODO mettere start e end
      // The cut is made inside getArrayTextblocksForPlaying
      this.textblocks=this.functions.getArrayTextblocksForPlaying(textblockToSplit, 0, this.bookmarkLetterAtGameBegin, this.functions.getIdCurrentBook(),this.gamesrulesModel.getChunkStart(this.functions.getIdCurrentBook(),this.currentChunk),this.gamesrulesModel.getChunkEnd(this.functions.getIdCurrentBook(),this.currentChunk));
      this.userdataModel.setIndexLastCharacterInBook(this.getWholeTextblockLength()-1);

      // Get the text to show prior or posterior
      this.setTextToShow();

      // get data of par necessary to this game and update opponent game array with scores
      this.dataExchanger.getScoreParDataofTextblockFromServer(this.functions.getIdCurrentBook(),this.getBeginSlicedTexblock(),this.getEndSlicedTexblock()).then((response)=>{
        this.parsOfTextblock=this.gamesrulesModel.getParsOfTextblock(this.functions.getIdCurrentBook(),this.getBeginSlicedTexblock(),this.getEndSlicedTexblock());
        //console.log("this.parsOfTextblock: "+JSON.stringify(this.parsOfTextblock));
        if(this.functions.isGameModeVersus()){
          this.updateScoreForOpponentGameDataVersus();
        }

        //console.log("this.parsOfTextblock: "+JSON.stringify(this.parsOfTextblock));
        this.resetLetterTriedHangman();
        this.initializemaxAttemptsWrongArray(this.getBeginSlicedTexblock(), this.getEndSlicedTexblock()).then((response)=>{
          if (this.functions.isGameModeVersus()) {
            this.initializeLettersGuessedOrNotHangmanVersusOpponent();
          }
          this.initializeArraysHangman();
      
          //if(this.functions.isGameModeShannonHangman()){
            this.numElementsToPlay=this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin), "all").length; 
          //}
          
          if(this.functions.isGameModeShannon() && !this.functions.isGameModeShannonHangman()){
            // count all characters in available textblocks
            // Removes from the count the characters of the sentence to be played that have been already guessed
            if(!this.functions.isGameModeShannonReverse()){
              this.numElementsToPlay=this.textblocks[0].slicedTextblock.length-(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin)); 
            }else{
              this.numElementsToPlay=(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin))+1; 
            }
          }
      
          this.resetlettersRemovedWhenThanosHit();
      
          resolve("splitText_shannonIsOk");;      
        });  
      });  
    });       
  }

  updateIndexesAndBookmark_shannon(isLastRound){
    console.log("--------UPDATE INDEXES--------"+"  Book:"+this.functions.getIdCurrentBook()+" Gamemode: "+this.functions.gamemode+"Chunk(InBook): "+this.currentChunk+" Start: "+this.currentChunkStart+" End:"+this.currentChunkEnd+" Tot Char:"+this.currentChunkTotalChar+"  ROUND:"+this.round+" and numElementsToPlay:"+this.numElementsToPlay+"  BEF indexElementToGuessInThisRound: "+this.indexElementToGuessInThisRound+"  BEF bookmarkLetterAtGameBegin:"+this.bookmarkLetterAtGameBegin+"  BEF currentBookmarkLetter:"+this.currentBookmarkLetter);

    /*if(this.round!=0 && !isLastRound && !this.functions.isGameModeShannonHangman()){
      //+1 (or -1) for the round increasing
      this.indexElementToGuessInThisRound=this.goNextDependingOnCurrentMode(this.indexElementToGuessInThisRound);
      this.currentBookmarkLetter=this.indexElementToGuessInThisRound+this.getBeginSlicedTexblock();
    }*/

    if(this.round!=0 && !isLastRound /*&& this.functions.isGameModeShannonHangman()*/){
      if (!this.functions.isGameModeShannonReverse()) {
        this.indexElementToGuessInThisRound=this.getIndexNextLetterWithCursor("right");
      }else{
        this.indexElementToGuessInThisRound=this.getIndexNextLetterWithCursor("left");
      }
      this.currentBookmarkLetter=this.indexElementToGuessInThisRound+this.getBeginSlicedTexblock();
    }

    if(isLastRound){
      //if (this.functions.isGameModeShannonHangman()){
        // indexFirstGuessableLetter return the first guessable according to mode, so it is ok even for reverse
        if (this.indexFirstGuessableLetter()!=-1) {
          this.currentBookmarkLetter=this.indexFirstGuessableLetter()+this.getBeginSlicedTexblock();
        }else{
          // If it does not find the index available it must go beyond if possible or end the book
          if (!this.functions.isGameModeShannonReverse()) {
            // if the used textblock is end of book goes past the end ending the game and the book
            this.currentBookmarkLetter=this.getEndSlicedTexblock()+1;
          }else{
            // if the used textblock is begin of book goes -1 ending the game and the book
            this.currentBookmarkLetter=this.getBeginSlicedTexblock()-1;
          }
        }
      //}
    }

    if(this.round==0 && !isLastRound){
      this.currentBookmark=0;
      this.currentBookmarkLetter=this.bookmarkLetterAtGameBegin;
      if (this.textblocks.length>0) {
        this.indexElementToGuessInThisRound=this.getIndexInSlicedArray(this.currentBookmarkLetter);
      }else{
        this.indexElementToGuessInThisRound=0;
      }
    }

    console.log("AFT indexElementToGuessInThisRound: "+this.indexElementToGuessInThisRound+"  AFT currentBookmarkLetter:"+this.currentBookmarkLetter+"  ----------------");
  }

  goNextDependingOnCurrentMode(element){
    if (!this.functions.isGameModeShannonReverse()) {
      return element+1;
    }
    if (this.functions.isGameModeShannonReverse()) {
      return element-1;
    }
  }

  setTextToShow(){
    var tmptextToShowPriorOrPosterior="";
    var numCharAvailable=0;
    var slicedTextblock=this.getSlicedTextblockToGuess();
    var beginTaking;
    var endTaking;
    var tmpIndexSpace;
    //console.log("getSlicedTextblockToGuess(): "+slicedTextblock);
    //console.log("this.currentBookmarkLetter: "+this.currentBookmarkLetter);

    if (!this.functions.isGameModeShannonReverse()) {
      numCharAvailable=this.getIndexInSlicedArray(this.currentBookmarkLetter); // not +1 for we must not consider the element on current bookmark
      if (numCharAvailable>=this.functions.numCharacterPriorOrPosterior) {
        
        beginTaking=this.getIndexInSlicedArray(this.currentBookmarkLetter)-this.functions.numCharacterPriorOrPosterior;
        endTaking=this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin);
        
        // This avoid to show incomplete words including char until the next space
        tmpIndexSpace=slicedTextblock.lastIndexOf(" ",beginTaking); //this search backwards
        if (tmpIndexSpace!=-1 && tmpIndexSpace!=beginTaking) {
          beginTaking=tmpIndexSpace;
        } 
        if (tmpIndexSpace==-1) {
          beginTaking=0;
        } 

        this.priorOrPosteriorIndexes=[beginTaking,endTaking-1]; // -1 for endTaking is not included in substring
        tmptextToShowPriorOrPosterior=slicedTextblock.substring(beginTaking,endTaking);
      }else{
        beginTaking=0;
        endTaking=this.getIndexInSlicedArray(this.currentBookmarkLetter);
        this.priorOrPosteriorIndexes=[beginTaking,endTaking];
        tmptextToShowPriorOrPosterior=slicedTextblock.substring(beginTaking,endTaking);
      }
    }else{
      numCharAvailable=slicedTextblock.length-1-this.getIndexInSlicedArray(this.currentBookmarkLetter);
      if (numCharAvailable>=this.functions.numCharacterPriorOrPosterior) {
        beginTaking=this.getIndexInSlicedArray(this.currentBookmarkLetter)+1;
        endTaking=this.getIndexInSlicedArray(this.currentBookmarkLetter)+this.functions.numCharacterPriorOrPosterior;
        
        // This avoid to show incomplete words including char until the next space
        tmpIndexSpace=slicedTextblock.indexOf(" ",endTaking);
        if (tmpIndexSpace!=-1 && tmpIndexSpace!=endTaking) {
          endTaking=tmpIndexSpace;
        } 
        if (tmpIndexSpace==-1) {
          endTaking=this.getIndexInSlicedArray(this.getEndSlicedTexblock());
        } 

        this.priorOrPosteriorIndexes=[beginTaking,endTaking-1]; // -1 for endTaking is not included in substring
        tmptextToShowPriorOrPosterior=slicedTextblock.substring(beginTaking,endTaking);
      } else {
        beginTaking=this.getIndexInSlicedArray(this.currentBookmarkLetter)+1;
        endTaking=slicedTextblock.length-1;
        this.priorOrPosteriorIndexes=[beginTaking,endTaking];
        tmptextToShowPriorOrPosterior=slicedTextblock.substring(beginTaking);
      } 
    } 

    if (!this.functions.isGameModeShannonReverse() && beginTaking>0) {
      tmptextToShowPriorOrPosterior="..."+tmptextToShowPriorOrPosterior;
    }
    if (!this.functions.isGameModeShannonReverse()) {
      tmptextToShowPriorOrPosterior=tmptextToShowPriorOrPosterior+"...";
    }
    if (this.functions.isGameModeShannonReverse() && endTaking<this.userdataModel.getIndexLastCharacterInBook()) {
      tmptextToShowPriorOrPosterior=tmptextToShowPriorOrPosterior+"...";
    }
    if (this.functions.isGameModeShannonReverse()) {
      tmptextToShowPriorOrPosterior="..."+tmptextToShowPriorOrPosterior;
    }

    tmptextToShowPriorOrPosterior="<div class='priorOrPosteriorDiv'>"+tmptextToShowPriorOrPosterior+"</div>";

    this.textToShowPriorOrPosterior=tmptextToShowPriorOrPosterior;
    //console.log("this.textToShowPriorOrPosterior: "+this.textToShowPriorOrPosterior);   
  }

  indexCurrentElementToGuessInTextblockWithMode(){
    if (!this.functions.isGameModeShannon()) {
      return this.indexElementToGuessInThisRound;
    }
    if (this.functions.isGameModeShannon()) {
      return 0; // in shannon we have only 1 element in textblocks
    }
    return
  }

  isLetterTried(index){
    var letterTried=false;
    if (index>=0 && index<this.numLettersInSingleKeyboards) {
      letterTried=(this.letterTriedInThisRound[this.currentKeyboard][index]==true);
    }
    return letterTried;
  }

  setLetterTried(indexesArray,indexLetter){
    if (indexLetter<0) {
      indexLetter=this.indexElementToGuessInThisRound;
    }
    for (let i = 0; i < indexesArray.length; i++) {
      //console.log("set to true element: ["+indexesArray[i][0]+","+indexesArray[i][1]+"]");
      this.letterTriedInThisRound[indexesArray[i][0]][indexesArray[i][1]]=true; 
    }

    //if (this.functions.isGameModeShannonHangman()) {
      // for example space bar is any keyboard, quotes and diacritics  are in two keyboard (uppercase and lowercase letters)
      for (let i = 0; i < indexesArray.length; i++) {
        //console.log("pushed in listOfLetterTriedInThisRound: ["+indexesArray[i][0]+","+indexesArray[i][1]+"]");
        this.listOfLetterTriedInThisRound[indexLetter].push(indexesArray[i]);
      }
    //}
  }

  resetLetterTried(){
    for (let i = 0; i < this.numKeyboardsAvailable; i++) {
      for (let j = 0; j < this.numLettersInSingleKeyboards; j++) {
        this.letterTriedInThisRound[i][j]=false;  
      }
    }
  }

  isGameEnded_shannon(){
    // Round starts from 0, that's why +1
    if((this.round)<this.numElementsToPlay){ 
      return false;
    }
    if((this.round)>=this.numElementsToPlay){
      return true;
    }
  }

  getSlicedTextblockToGuess(){
    return this.textblocks[0].slicedTextblock;
  }

  getWholeTextblockLength(){
    return this.textblocks[0].wholeTextblockLength;
  }

  getBeginSlicedTexblock(){
    return this.textblocks[0].beginSlicedTexblock;
  }

  getEndSlicedTexblock(){
    return this.textblocks[0].endSlicedTexblock;
  }

  getIndexInSlicedArray(index){
    return index-this.getBeginSlicedTexblock();
  }

  getBookmarkFromIndexInSlicedArray(index){
    return index+this.getBeginSlicedTexblock();
  }

  initializemaxAttemptsWrongArray(startBookmark,endBookmark){
    this.maxAttemptsWrong=[];
    var lenght=endBookmark-startBookmark+1;
    
    return new Promise((resolve) =>{
      for (let i = 0; i < lenght; i++) {
        if(!this.maxAttemptsWrong[i]){
          this.maxAttemptsWrong[i] = 0;
        }
      }

      this.dataExchanger.getMaxAttemptsWrongFromServer(startBookmark,endBookmark).then((maxAttemptsWrongJson)=>{
        //console.log("+++++++ getMaxAttemptsWrongFromServer: "+JSON.stringify(maxAttemptsWrongJson));
        var bookmarkInSlicedArray;
        for (var attempt in maxAttemptsWrongJson){ // this is strange, any other way the compiler doesn't accept it
          //console.log("++++++bletter: "+JSON.stringify(maxAttemptsWrongJson[attempt]));
          if (maxAttemptsWrongJson[attempt].bookmarkLetter>0 
          && maxAttemptsWrongJson[attempt].bookmarkLetter<endBookmark) {
            bookmarkInSlicedArray=this.getIndexInSlicedArray(maxAttemptsWrongJson[attempt].bookmarkLetter);
            this.maxAttemptsWrong[bookmarkInSlicedArray] = maxAttemptsWrongJson[attempt].attemptsWrong;
          }
          //console.log("+++ this.maxAttemptsWrong: "+JSON.stringify(this.maxAttemptsWrong));
        }
        resolve();
      });
    });
  }
  
  /* --------- FUNCTIONS GAME MODE HANGMAN --------- */
  
  /* This function initialize:
  - lettersGuessedOrNotHangman: if finds a letter guessed in previuos games it set the corresponding element in array to true
  - listOfLetterTriedInThisRound: if finds a letter guessed WRONG  in previuos games it set the corresponding element in array to set it tried
  */
  initializeArraysHangman(){
    var gamesdata=this.playModel.getWholeGamesData();
    this.lettersGuessedOrNotHangman=[];
    
    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if(!this.lettersGuessedOrNotHangman[i]){
        this.lettersGuessedOrNotHangman[i] = false;
      }
    }

    if (!this.functions.isGameModeVersus()) { // in game versus it must not care about what guessed in previous games
      for (let i = 0; i < gamesdata.length; i++) { // for each game played      
        // if this game is on the current book and the same mode of the current 
        if (gamesdata[i].idBook==this.functions.getIdCurrentBook() && 
          gamesdata[i].gamemode==this.functions.gamemode) {
          for (let j = 0; j < gamesdata[i].wordstyped.length; j++) { // for each attempt made in game played
            if (gamesdata[i].wordstyped[j].bookmarkLetter>=this.getBeginSlicedTexblock() 
            && gamesdata[i].wordstyped[j].bookmarkLetter<=this.getEndSlicedTexblock()) {
              if (gamesdata[i].wordstyped[j].isCorrect){
                this.lettersGuessedOrNotHangman[this.getIndexInSlicedArray(gamesdata[i].wordstyped[j].bookmarkLetter)]=true;
              }else{
                this.setLetterTried(this.getIndexInKeyboards(gamesdata[i].wordstyped[j].word,"allKeyboards","returnAllIndexes","doNOTchangeKeyboardWithIndexFound"),this.getIndexInSlicedArray(gamesdata[i].wordstyped[j].bookmarkLetter));             
              }
            }
          }
        }
      }  
    }

    if (!this.functions.isGameModeShannonReverse()) {
      this.fartherIndexDashReachedDuringGame=0;
    }else{
      this.fartherIndexDashReachedDuringGame=this.lettersGuessedOrNotHangman.length-1;
    }
    //console.log("FINAL this.lettersGuessedOrNotHangman: "+JSON.stringify(this.lettersGuessedOrNotHangman)); 
    this.updateCurrentGuessableString();
  }

  updateCurrentGuessableString(){
    var indexLastDashShowedOnScreen=this.indexLastGuessableLetter();
    var stainInt=1;
    var bookmarkOpponent=-1;
    var scoreForCurrentLetter, parForCurrentLetter;

    if (this.opponentGameDataVersus && this.functions.isGameModeVersus()) {
      if(this.opponentCurrentAttempt<=this.opponentGameDataVersus.length){
        bookmarkOpponent=this.opponentGameDataVersus[this.opponentCurrentAttempt-1].bookmarkLetter;
      }else{
        bookmarkOpponent=-1;
      }
    }
    
    if (!this.functions.isGameModeShannonReverse()) {
      this.fartherIndexDashReachedDuringGame=Math.max(this.fartherIndexDashReachedDuringGame,indexLastDashShowedOnScreen);
      indexLastDashShowedOnScreen=Math.max(this.fartherIndexDashReachedDuringGame,indexLastDashShowedOnScreen);
    }else{
      this.fartherIndexDashReachedDuringGame=Math.min(this.fartherIndexDashReachedDuringGame,indexLastDashShowedOnScreen);
      indexLastDashShowedOnScreen=Math.min(this.fartherIndexDashReachedDuringGame,indexLastDashShowedOnScreen);
    }
    this.currentGuessableString="";

    for (let i = 0; i < this.lettersGuessedOrNotHangman.length; i++) {
      if(i>=this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin) 
          && i<=indexLastDashShowedOnScreen 
          && !this.functions.isGameModeShannonReverse()
      || i<=this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin) 
        && i>=indexLastDashShowedOnScreen 
        && this.functions.isGameModeShannonReverse()){
        
        this.currentGuessableString+='<div class="letterBoxContainer';
        if (this.functions.isGameModeVersus()) {
          if (i==this.getIndexInSlicedArray(bookmarkOpponent)) {
            this.currentGuessableString+=' opponentBookmark ';
          }
        }

        this.currentGuessableString+='">';

        if (this.functions.isGameModeVersus()) {
          if (i==this.getIndexInSlicedArray(bookmarkOpponent)
          || (bookmarkOpponent==-1 && i==this.indexLastGuessableLetter())) {
            if (this.currentColorCatVersus!="none") {
              this.currentGuessableString+='<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_robot_white_'+this.currentColorCatVersus+'.png"><img class="robot_top" src="assets/img/rubedo_robot_white.png"></div>';
              this.currentColorCatVersus="none";
            }else{
              this.currentGuessableString+='<div class="letterHidden robotcat catOn"><img class="robot_bottom" src="assets/img/rubedo_robot_white.png"><img class="robot_top" src="assets/img/rubedo_robot_white.png"></div>';
            }
          }else{
            this.currentGuessableString+='<div class="letterHidden robotcat catOff"><img src="assets/img/rubedo_robot_white.png"></div>';
          }
        }

        if (this.lettersGuessedOrNotHangman[i]==true) {
          parForCurrentLetter=this.getParOfBookmark(i+this.getBeginSlicedTexblock());
          scoreForCurrentLetter=this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i],parForCurrentLetter);
          
          if(this.textblocks[0].slicedTextblock[i]==" "){
            this.currentGuessableString+='<div class="letterClear">&#8239;</div>';
          }else{
            this.currentGuessableString+='<div class="letterClear">'+this.textblocks[0].slicedTextblock[i]+'</div>';
          }
          // For the next for maxAttemptsWrong contains only error and not the correct guess
          this.currentGuessableString+='<div class="numUnderDash numUnderDashGuessed';
          this.currentGuessableString+='">'+scoreForCurrentLetter+'</div>'; 
        }else{
          //parForCurrentLetter=this.getParOfBookmark(i+this.getBeginSlicedTexblock());
          //scoreForCurrentLetter=this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i],parForCurrentLetter);
          
          //console.log("i: "+i+" cbl: "+this.currentBookmarkLetter+" blb: "+this.bookmarkLetterAtGameBegin);
          if(i==this.getIndexInSlicedArray(this.currentBookmarkLetter)){
            // If this is the letter currently highlighted and played
            this.currentGuessableString+='<div class="blinking_underscore';
            //if (this.maxAttemptsWrong[i]>parForCurrentLetter) {
              this.currentGuessableString+=' qm_'+this.currentBlinkingCursorColor+' ';
            //}else{
              //this.currentGuessableString+=' qm_green ';
            //}
            this.currentGuessableString+='" id="blinking_underscore_id">__</div>';
          }else{
            // If this is NOT the letter currently highlighted and played
            if (stainInt>=4) {
              stainInt=1;
            } else {
              stainInt++;
            }
            this.currentGuessableString+='<div class="letterHidden ';
            /*if (this.functions.isGameModeVersus()) {
              if (this.lettersGuessedOrNotHangmanVersusOpponent[i]==true) {
                this.currentGuessableString+=' dashgreen ';
              }
            }*/
            this.currentGuessableString+=' ">'+'<img src="assets/img/stain'+stainInt;
            if (this.functions.isGameModeVersus()) {
              if (this.lettersGuessedOrNotHangmanVersusOpponent[i]) {
                if (this.lettersGuessedOrNotHangmanVersusOpponent[i]==true) {
                  this.currentGuessableString+='';
                }else{
                  this.currentGuessableString+='_grsc';
                }
              }else{
                this.currentGuessableString+='_grsc';
              }
            }else{
              this.currentGuessableString+='_grsc';
            }
            this.currentGuessableString+='.png">'/*this.functions.symbolLetterHidden*/+'</div>';
          }
          // For visualization you show the score available if you go right for the 'next' attempt
          //this.currentGuessableString+='<div class="numUnderDash">'+this.gamesrulesModel.calculateScoreForNextAttempt(this.maxAttemptsWrong[i],this.getParOfBookmark(i+this.getBeginSlicedTexblock()))+'</div>'; 
          this.currentGuessableString+='<div class="numUnderDash invisibleOccSpace';
          //console.log("score: "+scoreForCurrentLetter+" par:"+parForCurrentLetter);
          this.currentGuessableString+='">'+scoreForCurrentLetter+'</div>'; 
        }
       
        //this.currentGuessableString+='<div class="numUnderDash">'+this.maxAttemptsWrong[i]+'</div>';  
        
              
        this.currentGuessableString+='</div>'; 
      }
    }

    this.currentGuessableString="<div class='currentGuessableStringDiv'>"+this.currentGuessableString+"</div>";
    
    /* innerHTML strips away 'id' tag for security reasons. This way, id is retained */
   if (!this.functions.isGameModeShannonReverse()) {
    this.showablecurrentGuessableString=this.sanitizer.bypassSecurityTrustHtml(this.textToShowPriorOrPosterior+this.currentGuessableString);
   }else{
    this.showablecurrentGuessableString=this.sanitizer.bypassSecurityTrustHtml(this.currentGuessableString+this.textToShowPriorOrPosterior);
   }
   //console.log("this.currentGuessableString: !"+this.currentGuessableString+"!");
  }

  getParOfBookmark(bookmark){
    //console.log("++++ bookmark: "+JSON.stringify(bookmark));
    // Find instead of filter just to save some computations (find the first element instead of looping them all)
    var bookmarkParData=this.parsOfTextblock.find(obj=>obj.bookmarkInChunk==bookmark); 
    // It could have been [this.getIndexInSlicedArray(bookmark)]; if they were synchronized, 
    // but no for there is the fucked last character with no par record in db
    //console.log("++++ bookmarkParData: "+JSON.stringify(bookmarkParData));
    return bookmarkParData.par; 
  }

  moveCursor(direction){
    var index=this.getIndexNextLetterWithCursor(direction);
    if(index>=0){
      this.currentBookmarkLetter=index+this.getBeginSlicedTexblock();
      this.indexElementToGuessInThisRound=index;
      this.updateArrayLetterTriedHangman();
      this.updateThermometer(this.currentBookmarkLetter);
    }
    //console.log("currBletter: "+this.currentBookmarkLetter+" index:"+this.indexElementToGuessInThisRound);
    this.updateCurrentGuessableString();
  }

  getIndexNextLetterWithCursor(direction){
      var index;

      if (direction=="right") {
        index=this.getIndexNextLetterWithCursorRight();
        if (index==-1) { // If arrives at the end findind nothing, try in the other direction
          index=this.getIndexNextLetterWithCursorLeft();
          return index;
        }else{
          return index;
        }
      }

      if (direction=="left") {
        index=this.getIndexNextLetterWithCursorLeft();
        if (index==-1) { // If arrives at the end findind nothing, try in the other direction
          index=this.getIndexNextLetterWithCursorRight();
          return index;
        }else{
          return index;
        }
      }
      
      return -1;
  }

  // TODO use the indexes function for this
  getIndexNextLetterWithCursorRight(){
    //console.log("+++++++++++++++ getIndex RIGHT");
    //console.log("+++++++++++++++ this.currentBookmarkLetter: "+this.currentBookmarkLetter);
    var index;

    if (!this.functions.isGameModeShannonReverse()) { index=this.indexLastGuessableLetter(); }
    if (this.functions.isGameModeShannonReverse()) { index=this.indexFirstGuessableLetter(); }
    //console.log("+++++++++++++++ RIGHT index: "+index);

    if (this.getIndexInSlicedArray(this.currentBookmarkLetter)==index
      || index==-1) { 
        return this.getIndexInSlicedArray(this.currentBookmarkLetter); // no going right of the ending 
    }

    for (let i = 0; i < this.lettersGuessedOrNotHangman.length; i++) {
      //console.log("i: "+i);
      if(i>this.getIndexInSlicedArray(this.currentBookmarkLetter)){
        if(this.lettersGuessedOrNotHangman[i]==false){
          //console.log("+++++++++++++++ index found: "+i);
          return i;
        }
      } 
    }

    return -1;
  }

  getIndexNextLetterWithCursorLeft(){
    //console.log("+++++++++++++++ getIndex LEFT");
    //console.log("+++++++++++++++ this.currentBookmarkLetter: "+this.currentBookmarkLetter);

    var index;

    if (!this.functions.isGameModeShannonReverse()) { index=this.indexFirstGuessableLetter(); }
    if (this.functions.isGameModeShannonReverse()) { index=this.indexLastGuessableLetter(); }
    //console.log("+++++++++++++++ LEFT index: "+index);

    if (this.getIndexInSlicedArray(this.currentBookmarkLetter)==index
      || index==-1) { 
        return this.getIndexInSlicedArray(this.currentBookmarkLetter); // no going right of the ending 
    }

    for (let i = this.lettersGuessedOrNotHangman.length; i >= 0; i--) {
      //console.log("i: "+i);
      if(i<this.getIndexInSlicedArray(this.currentBookmarkLetter)){
        if(this.lettersGuessedOrNotHangman[i]==false){
          //console.log("+++++++++++++++ index found: "+i);
          return i;
        }
      } 
    }
    
    return -1;
  }

  getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(index,numElementToTake){
    var direction;
    if (!this.functions.isGameModeShannonReverse()) {
      direction="right";
    }else{
      direction="left";
    }
    return this.getNextGuessableLettersIndexesInLettersGuessedOrNotHangman(index,direction,numElementToTake);
  }
  

  // returns [] if doesn't find indexes or error are raised
  getNextGuessableLettersIndexesInLettersGuessedOrNotHangman(index,direction,numElementToTake){
    var indexesFound=[];
    if (numElementToTake=="all") {
      numElementToTake=this.lettersGuessedOrNotHangman.length;
    }
    if (index<0 || index>=this.lettersGuessedOrNotHangman.length) {
      console.log("ERROR: trying to find next guessable char with index out of boundaries!");
      return [];
    }

    if (direction=="right") {
      while (index<this.lettersGuessedOrNotHangman.length && numElementToTake>0) {
        //console.log("****** index: "+index+" numElementToTake: "+numElementToTake);
        if (this.lettersGuessedOrNotHangman[index]==false) {
          indexesFound.push(index);
          numElementToTake--;
          index++;
          //console.log("****** index found: "+JSON.stringify(indexesFound)+" numElementToTake: "+numElementToTake);
        }else{
          index++;
          //console.log("****** retry!");
        }
      }
    } 
    
    if (direction=="left") {
      while (index>=0 && numElementToTake>0) {
        //console.log("****** index: "+index+" numElementToTake: "+numElementToTake);
        if (this.lettersGuessedOrNotHangman[index]==false) {
          indexesFound.push(index);
          numElementToTake--;
          index--;
          //console.log("****** index found: "+JSON.stringify(indexesFound)+" numElementToTake: "+numElementToTake);
        }else{
          index--;
          //console.log("****** retry!");
        }
      }
    }

    //console.log("FINAL NextGuessableLettersIndexesInLettersGuessedOrNotHangman found: "+indexesFound);
    return indexesFound;
  }

  indexFirstGuessableLetter(){
    /* The first guessable is the first normally reading the guessable string from left to right
    In reverse is the first reading right to left */
    var indexesFound=this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin), 1);
    if (indexesFound.length>0) {
      return indexesFound[0];
    } else {
      return -1;
    }
  }

  indexLastGuessableLetter(){
    /* The last guessable is the last normally reading the guessable string from left to right
    In reverse is the last reading right to left  */
    var indexesFound;
    var tmpNumLetterGuessableSimul=0;

    if (this.functions.isGameModeVersus() && this.maxBookmarkReachedOpponent){
      tmpNumLetterGuessableSimul=Math.max(this.maxBookmarkReachedOpponent-this.minBookmarkReachedOpponent,this.functions.numLetterGuessableSimul[this.functions.gamemode]);
    }else{
      tmpNumLetterGuessableSimul=this.functions.numLetterGuessableSimul[this.functions.gamemode];
    }

    //console.log("++++++++++this.functions.numLetterGuessableSimul[this.functions.gamemode]: "+this.functions.numLetterGuessableSimul[this.functions.gamemode]);
    //console.log("++++++++++tmpNumLetterGuessableSimul: "+tmpNumLetterGuessableSimul);
    //console.log("++++++++++Math.max: "+Math.max(this.maxBookmarkReachedOpponent-this.minBookmarkReachedOpponent,this.functions.numLetterGuessableSimul[this.functions.gamemode]));
    
    indexesFound=this.getNextGuessableLettersIndexesAccordingCurrentModeInLettersGuessedOrNotHangman(this.getIndexInSlicedArray(this.bookmarkLetterAtGameBegin),tmpNumLetterGuessableSimul);

    //qui indice maggiore ra indexFound e ultimo opponent this.minBookmarkReachedOpponent
    if (indexesFound.length>0) {
      /*if (this.functions.isGameModeVersus()) {
        console.log("indexesFound[indexesFound.length-1]: "+(indexesFound[indexesFound.length-1]));
          console.log("this.maxBookmarkReachedOpponent: "+this.maxBookmarkReachedOpponent);
          console.log("Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedOpponent): "+Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedOpponent));
        if (this.maxBookmarkReachedOpponent) {
          return Math.max(indexesFound[indexesFound.length-1],this.maxBookmarkReachedOpponent);
        }else{
          return indexesFound[indexesFound.length-1];
        }
      }else{
        return indexesFound[indexesFound.length-1];
      }*/

      return indexesFound[indexesFound.length-1];
      
    } else {
      return -1;
    }
  }

  resetLetterTriedHangman(){
    this.listOfLetterTriedInThisRound=[];
    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if(!this.listOfLetterTriedInThisRound[i]){
        this.listOfLetterTriedInThisRound[i] = [];
      }
    }
  }

  isThanosModeActive(){
    if(this.functions.percLetterToRemoveInThanosMode[this.functions.difficulty]!=0){
      return true;
    }else{
      return false;
    }
  }

  resetlettersRemovedWhenThanosHit(){ 
    if (this.isThanosModeActive()) {
      this.lettersRemovedWhenThanosHit=[];
      for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
        if(!this.lettersRemovedWhenThanosHit[i]){
          this.lettersRemovedWhenThanosHit[i] = [0];
        }
      }
    }
  }

  updateArrayLetterTriedHangman(){
    this.resetLetterTried();
    for (let i = 0; i < this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound].length; i++) {
      this.letterTriedInThisRound[this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound][i][0]][this.listOfLetterTriedInThisRound[this.indexElementToGuessInThisRound][i][1]]=true;
    }
  }
  /* --------- END FUNCTIONS GAME MODE HANGMAN --------- */

  intro() {
    //var device = this.functions.getCurrentDevice();
    var numTutorialSteps=15;
    var skipLabel="Skip";
    var doneLabel="Done";
    var nextLabel=">";
    var prevLabel="<";
    var idMoodOnStep;

    if (this.functions.getLanguage()=="it") {
      skipLabel="Salta";
      doneLabel="Fatto";
    }
    var tutorialSteps={
      tooltipClass: 'introTooltip',
      showStepNumbers: false,
      exitOnEsc: true,
      overlayOpacity: 1,
      showBullets: false,
      steps: [],
      hidePrev: true,
      hideNext: true,
      keyboardNavigation: false, // enabling this cause an error if going after the end of tutorial using arrow button on keyboard
      skipLabel: skipLabel,
      doneLabel: doneLabel,
      nextLabel: nextLabel,
      prevLabel: prevLabel
    };
    this.tutorialIsRunning=true;
    
    for (let i = 0; i <= numTutorialSteps-1; i++) {
      this.translate.get("tutorial_step_"+i).subscribe(value => { 
        this.tutorialMessages[i]=value;
      });
      this.translate.get("tutorial_step_"+i+"_id_element").subscribe(value => { 
        this.tutorialIdElement[i]=value;
      });
      this.translate.get("tutorial_step_"+i+"_position").subscribe(value => { 
        this.tutorialPosition[i]=value;
      });
    }

    // Skip step 5 of tutorial on mobile
    var isMobile=this.functions.isCurrentDevice('mobile');
    if (isMobile) {
      this.tutorialMessages.splice(5, 1);
      this.tutorialIdElement.splice(5, 1);
      this.tutorialPosition.splice(5, 1);
      numTutorialSteps--;
    }

    for (let i = 0; i <= numTutorialSteps-1; i++) {
      tutorialSteps.steps.push({
        element: this.tutorialIdElement[i],
        intro: this.tutorialMessages[i],
        position: this.tutorialPosition[i]
      });
    }

    this.introJsVar.setOptions(tutorialSteps);
    
    // Here I use arrow function in order not to loose the context 'this'
    this.introJsVar.onbeforechange(()=> {
      idMoodOnStep=this.introJsVar._currentStep;
      if (isMobile && idMoodOnStep>=5) {
        idMoodOnStep++;
      }
      this.translate.get("tutorial_step_"+idMoodOnStep+"_mood").subscribe(value => { 
        this.mood=value;
      });
    });

    this.introJsVar.oncomplete(()=> {
      this.tutorialIsRunning=false;
      //this.userdataModel.setCollectibleGot(1);
    });

    this.introJsVar.onexit(()=> {
      this.tutorialIsRunning=false;
    });

    this.introJsVar.start();
  }

  /* --------- FUNCTIONS GAME MODE VERSUS --------- */

  getSingleGameDataVersus(guidUser,idGame,idBook,gamemode,language,opponentIsAI){
    return new Promise((resolve) =>{
      this.dataExchanger.getSingleGameForVersus(guidUser,idGame,idBook,gamemode,language,opponentIsAI).then((initialGameDataForVersus)=>{
        this.initialGameDataForVersus=initialGameDataForVersus;
        resolve("getSingleGameDataVersusIsOk")
      });
    });
  }

  getSingleGameAIdataToCompare(guidUser,idBook,chunkStart){
    return new Promise((resolve) =>{
      this.dataExchanger.getSingleGameAIdataToCompareExchanger(guidUser,idBook,chunkStart).then((response)=>{
        this.scoreFinalAI=response['scoreFinal'];
        this.entropyFinalAI=this.functions.roundTwoDecimal(response['up_entropy']);
      });
    });
  }

  initializeLettersGuessedOrNotHangmanVersusOpponent(){
    this.lettersGuessedOrNotHangmanVersusOpponent=[];
    
    for (let i = 0; i < this.getSlicedTextblockToGuess().length; i++) {
      if(!this.lettersGuessedOrNotHangmanVersusOpponent[i]){
        this.lettersGuessedOrNotHangmanVersusOpponent[i] = false;
      }
    }
  }

  timerVersus(){
    this.refreshIntervalId = setInterval(()=>{
      if (!this.isGameEndedBoolean && !this.tutorialIsRunning) {
        this.time++;
      }

      // check if player is ahead opponent or the opposite and endgame with win or lost outcome
      // Player Wins challenge!
      //console.log("score plr vs opp: "+this.attempt+" - "+this.opponentCurrentAttempt+"/"+(this.opponentGameDataVersus.length));

      /* -----------
      // This makes the player or opponent win if: opponent completes his game before player arrives where opponents arrived
      if(this.attempt>=(this.opponentGameDataVersus.length)){
        this.endgame("win_versus");
        return;
      }
      // Opponent Wins challenge!
      if (this.opponentCurrentAttempt>=this.opponentGameDataVersus.length) {
        this.endgame("lost_versus");
        return;
      }
      ----------- */
      if (this.opponentCurrentAttempt<=this.opponentGameDataVersus.length) { // If opponent has done his game, then stop
        //console.log("----------------");
        //console.log("this.opponentCurrentAttempt: "+this.opponentCurrentAttempt+" this.opponentGameDataVersus.length: "+this.opponentGameDataVersus.length);
        //console.log("current time: "+this.time+" opponent time:"+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].time+" iscorrect: "+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].isCorrect)
        if(this.time>=this.opponentGameDataVersus[this.opponentCurrentAttempt-1].time){
          this.currentColorCatVersus="red";
          // You could have more than one attempt in the same second X, so here it is the reason for this while
          while (this.time>=this.opponentGameDataVersus[this.opponentCurrentAttempt-1].time) {
            if (this.opponentGameDataVersus[this.opponentCurrentAttempt-1].isCorrect) {
              //console.log("Opponent Avanza! Current attempt: "+this.opponentCurrentAttempt+" time:"+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].time+" bookmarkLetter: "+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].bookmarkLetter);
              this.lettersGuessedOrNotHangmanVersusOpponent[this.getIndexInSlicedArray(this.opponentGameDataVersus[this.opponentCurrentAttempt-1].bookmarkLetter)]=true;  
              this.currentColorCatVersus="green";
            }else{
              //console.log("Opponent NON Avanza! Current attempt: "+this.opponentCurrentAttempt+" time:"+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].time+" bookmarkLetter: "+this.opponentGameDataVersus[this.opponentCurrentAttempt-1].bookmarkLetter);  
            }
            if ((this.opponentCurrentAttempt+1)<this.opponentGameDataVersus.length) {
              if (this.opponentGameDataVersus[this.opponentCurrentAttempt-1].isCorrect) {
                this.currentScoreAi=this.opponentGameDataVersus[this.opponentCurrentAttempt-1].score;
              }
              this.opponentCurrentAttempt++;
            } else if ((this.opponentCurrentAttempt+1)>=this.opponentGameDataVersus.length) {

              if (this.opponentGameDataVersus[this.opponentCurrentAttempt-1].isCorrect) {
                this.currentScoreAi=this.opponentGameDataVersus[this.opponentCurrentAttempt-1].score;
              }
              this.opponentCurrentAttempt++;
              break;
            } 
          }
          this.updateCurrentGuessableString();
        }
      //console.log("----------------");
      }else{
        this.currentColorCatVersus="none";
      }
    },1000);
  }

  convertTimestamp(timestampInMilliseconds){
    return (timestampInMilliseconds-(timestampInMilliseconds%1000))/1000;
  }

  changeSettingsBeforeGameVersus(){
    this.savedSettingsBeforeVersusGame[0]=this.functions.gamemode;
    this.savedSettingsBeforeVersusGame[1]=this.functions.getIdCurrentBook();
    //console.log("--- Saving gamemode: "+this.savedSettingsBeforeVersusGame[0]+" book: "+this.savedSettingsBeforeVersusGame[1]);
    this.functions.setGamemodeTo("shannon_hangman");
    this.functions.setIdCurrentBook(this.initialGameDataForVersus[0].idBook);
  }
  
  restoringSettingsAfterGameVersus(){
    this.functions.setGamemodeTo(this.savedSettingsBeforeVersusGame[0]);
    this.functions.setIdCurrentBook(this.savedSettingsBeforeVersusGame[1]);
    //console.log("--- Restoring gamemode: "+this.savedSettingsBeforeVersusGame[0]+" book: "+this.savedSettingsBeforeVersusGame[1]);
  }

  chooseBookVersus(){
    var randomItem=0;
    var bookPlayableInCurrentLanguage=[];
    for (let i = 0; i < this.functions.booksPlayableInVersus.length; i++) {
      if (this.userdataModel.getLanguageofBook(this.functions.booksPlayableInVersus[i])==this.functions.language) {
        bookPlayableInCurrentLanguage.push(this.functions.booksPlayableInVersus[i]);
      }
    }
    if (bookPlayableInCurrentLanguage.length==0) {
      console.log("ERROR: book available for versus not found!");
      return 1;
    }
    randomItem=this.functions.getRandomIntBetween(0,bookPlayableInCurrentLanguage.length-1);
    return bookPlayableInCurrentLanguage[randomItem];
  }

  getNextChunk(idChunkInBook){
    if (this.functions.isGameModeShannonReverse()) {
      return idChunkInBook-1;
    }else{
      return idChunkInBook+1;
    }
  }

  skipChunkIfNotEnoughTextToShowForPriorOrPosterior(){
    var chunkTmp=this.userdataModel.getCurrentIdChunkInBook();
    var chunkCharSkipped=0;
    var chunkLenght=0;
    var numChunkSkipped=0;
    //console.log("+++++++ chunkTmp: "+chunkTmp);
    // If chunk is the first or the last and numCharacterPriorOrPosterior is longer than the chunk skip 
    // to the first possible, allowing a text to show long at least numCharacterPriorOrPosterior
    if ( 
       (!this.functions.isGameModeShannonReverse() && chunkTmp==0)
    || (this.functions.isGameModeShannonReverse() && chunkTmp==(this.userdataModel.getNumchunktotalOfBook(this.functions.getIdCurrentBook())-1) )
    ) {
      chunkCharSkipped=this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(),chunkTmp);
      //console.log("+++++++ IN! chunkCharSkipped: "+chunkCharSkipped);
      
      //console.log("this.numChunksInBook: "+this.numChunksInBook);
      while (chunkCharSkipped<=this.functions.numCharacterPriorOrPosterior && chunkTmp>=0 && chunkTmp<=this.numChunksInBook) {
        chunkTmp=this.getNextChunk(chunkTmp);
        numChunkSkipped++;
        //console.log("+++++++ next chunkTmp: "+chunkTmp);
        chunkLenght=this.gamesrulesModel.getChunkLength(this.functions.getIdCurrentBook(),chunkTmp);
        //console.log("+++++++ next chunkLength: "+chunkLenght);
        if ((chunkCharSkipped+chunkLenght)>this.functions.numCharacterPriorOrPosterior) {
          // -numChunkSkipped to add a char for every chunk skipped for every chunk has a final char that is not calculated but used as one char in numCharacterPriorOrPosterior
          this.chunkCharSkippedAtBeginningOrEndOfBook=this.functions.numCharacterPriorOrPosterior-chunkCharSkipped-numChunkSkipped; 
          //console.log("+++++++ chunkCharSkippedAtBeginningOrEndOfBook: "+this.chunkCharSkippedAtBeginningOrEndOfBook);
        }
        chunkCharSkipped=chunkCharSkipped+chunkLenght;
        //console.log("+++++++ next chunkCharSkipped: "+chunkCharSkipped);
      }
    }
    
    this.currentChunk=chunkTmp;
  }

  updateThermometer(bookmarkLetter){
    var scoreMissed = this.gamesrulesModel.calculateScore(this.maxAttemptsWrong[this.getIndexInSlicedArray(bookmarkLetter)]+1,this.getParOfBookmark(bookmarkLetter));
    var scoreEarnable = this.gamesrulesModel.calculateScore(1,this.getParOfBookmark(bookmarkLetter));
    this.currentThermometerColor = "#FFFFFF";   
    var scoreMissedPercOverOrUnderPar;
    this.currentThermometerProgress=this.functions.calculatePercentage(scoreMissed,scoreEarnable,"scoreEarnableAndMissed");

    if (scoreMissed>=this.gamesrulesModel.scoreExactlyOnPar) {
      // over par
      this.currentBlinkingCursorColor="green";
      scoreMissedPercOverOrUnderPar=this.functions.calculatePercentage(scoreMissed-100,scoreEarnable-100,"scoreEarnableAndMissed");
      if (scoreMissedPercOverOrUnderPar>=80 && scoreMissedPercOverOrUnderPar<=100) { this.currentThermometerColor="#339900"; }
      if (scoreMissedPercOverOrUnderPar>=60 && scoreMissedPercOverOrUnderPar<80) { this.currentThermometerColor="#33A61A"; }
      if (scoreMissedPercOverOrUnderPar>=40 && scoreMissedPercOverOrUnderPar<60) { this.currentThermometerColor="#33B333"; }
      if (scoreMissedPercOverOrUnderPar>=20 && scoreMissedPercOverOrUnderPar<40) { this.currentThermometerColor="#33BF4D"; }
      if (scoreMissedPercOverOrUnderPar>=0 && scoreMissedPercOverOrUnderPar<20) { this.currentThermometerColor="#33CC66"; }
        
    }else if (scoreMissed<this.gamesrulesModel.scoreExactlyOnPar){
      //under par
      this.currentBlinkingCursorColor="red";
      scoreMissedPercOverOrUnderPar=this.functions.calculatePercentage(scoreMissed,100,"scoreEarnableAndMissed");
      if (scoreMissedPercOverOrUnderPar>=80 && scoreMissedPercOverOrUnderPar<=100) { this.currentThermometerColor="#FF6666 "; }
      if (scoreMissedPercOverOrUnderPar>=60 && scoreMissedPercOverOrUnderPar<80) { this.currentThermometerColor="#FF4D4D "; }
      if (scoreMissedPercOverOrUnderPar>=40 && scoreMissedPercOverOrUnderPar<60) { this.currentThermometerColor="#FF3333"; }
      if (scoreMissedPercOverOrUnderPar>=20 && scoreMissedPercOverOrUnderPar<40) { this.currentThermometerColor="#FF1A1A"; }
      if (scoreMissedPercOverOrUnderPar>=0 && scoreMissedPercOverOrUnderPar<20) { this.currentThermometerColor="#FF0000"; }
    }
    /* https://meyerweb.com/eric/tools/color-blend/#FF0000:FF99CC:4:hex */
    
    this.events.publish('updateThermometerColor',this.currentThermometerColor);

    /* superhappy - happy
    worried - superworried
    angry - superangry
    sad - supersad */

    if (this.currentThermometerProgress==100) {
      if(this.mood=='happy'){
        this.mood='superhappy';
      }else{
        this.mood='happy';
      }
    }
    
    if (this.currentThermometerProgress>=80 && this.currentThermometerProgress<100) {
      switch (this.mood) {
        case 'worried':
          this.mood='superworried';
          break;
        case 'superworried':
          this.mood='worried';
          break;
        default:
          this.mood='worried';
          break;
      }
    }
    if (this.currentThermometerProgress>=60 && this.currentThermometerProgress<80) {
      switch (this.mood) {
        case 'angry':
          this.mood='superworried';
          break;
        case 'superworried':
          this.mood='angry';
          break;
        default:
          this.mood='superworried';
          break;
      }
    }
    if (this.currentThermometerProgress>=40 && this.currentThermometerProgress<60) {
      switch (this.mood) {
        case 'angry':
          this.mood='superangry';
          break;
        case 'superangry':
          this.mood='angry';
          break;
        default:
          this.mood='angry';
          break;
      }
    }
    if (this.currentThermometerProgress>=20 && this.currentThermometerProgress<40) {
      switch (this.mood) {
        case 'sad':
          this.mood='superangry';
          break;
        case 'superangry':
          this.mood='sad';
          break;
        default:
          this.mood='superangry';
          break;
      }
    }

    if (this.currentThermometerProgress>=0 && this.currentThermometerProgress<20) {
      switch (this.mood) {
        case 'sad':
          this.mood='supersad';
          break;
        case 'supersad':
          this.mood='sad';
          break;
        default:
          this.mood='sad';
          break;
      }
    }
    //console.log("++++ scoreMissed: "+scoreMissed+" scoreEarnable: "+scoreEarnable);
    //console.log("++++ this.currentThermometerProgress: "+this.currentThermometerProgress+"%");
  }
}


// WEBPACK FOOTER //
// ./src/pages/play/play.ts